const tonalitiesCorrespondances = {
    'C':{
      Af:'',
      A:'A',
      Bf:'',
      B:'B',
      C:'C',
      Df:'',
      D:'D',
      Ef:'',
      E:'E',
      F:'F',
      Fs:'',
      G:'G'
    },
    'G':{
      Af:'',
      A:'A',
      Bf:'',
      B:'B',
      C:'C',
      Df:'',
      D:'D',
      Ef:'',
      E:'E',
      F:'',
      Fs:'Fs',
      G:'G'
    },
    'D':{
      Af:'',
      A:'A',
      Bf:'',
      B:'B',
      C:'',
      Df:'Cs',
      D:'D',
      Ef:'',
      E:'E',
      F:'',
      Fs:'Fs',
      G:'G'
    },
    'A':{
      Af:'Gs',
      A:'A',
      Bf:'',
      B:'B',
      C:'',
      Df:'Cs',
      D:'D',
      Ef:'',
      E:'E',
      F:'',
      Fs:'Fs',
      G:''
    },
    'E':{
      Af:'Gs',
      A:'A',
      Bf:'',
      B:'B',
      C:'',
      Df:'Cs',
      D:'',
      Ef:'Ds',
      E:'E',
      F:'',
      Fs:'Fs',
      G:''
    },
    'B':{
      Af:'Gs',
      A:'',
      Bf:'As',
      B:'B',
      C:'',
      Df:'Cs',
      D:'',
      Ef:'Ds',
      E:'E',
      F:'',
      Fs:'Fs',
      G:''
    },
    'Fs':{
      Af:'Gs',
      A:'',
      Bf:'As',
      B:'B',
      C:'',
      Df:'Cs',
      D:'',
      Ef:'Ds',
      E:'',
      F:'Es',
      Fs:'Fs',
      G:''
    },
    'Df':{
      Af:'Af',
      A:'',
      Bf:'Bf',
      B:'',
      C:'C',
      Df:'Df',
      D:'',
      Ef:'Ef',
      E:'',
      F:'F',
      Fs:'Gf',
      G:''
    },
    'Af':{
      Af:'Af',
      A:'',
      Bf:'Bf',
      B:'',
      C:'C',
      Df:'Df',
      D:'',
      Ef:'Ef',
      E:'',
      F:'F',
      Fs:'',
      G:'G'
    },
    'Ef':{
      Af:'Af',
      A:'',
      Bf:'Bf',
      B:'',
      C:'C',
      Df:'',
      D:'D',
      Ef:'Ef',
      E:'',
      F:'F',
      Fs:'',
      G:'G'
    },
    'Bf':{
      Af:'',
      A:'A',
      Bf:'Bf',
      B:'',
      C:'C',
      Df:'',
      D:'D',
      Ef:'Ef',
      E:'',
      F:'F',
      Fs:'',
      G:'G'
    },
    'F':{
      Af:'',
      A:'A',
      Bf:'Bf',
      B:'',
      C:'C',
      Df:'',
      D:'D',
      Ef:'',
      E:'E',
      F:'F',
      Fs:'',
      G:'G'
    },
};
const notesCorrespondances = [
    [
      'Af','Ef','Bf','F'
    ],
    [
      'A','E','B','Fs'
    ],
    [
      'Bf','F','C','G'
    ],
    [
      'B','Fs','Df','Af'
    ],
    [
      'C','G','D','A'
    ],
    [
      'Df','Af','Ef','Bf'
    ],
    [
      'D','A','E','B'
    ],
    [
      'Ef','Bf','F','C'
    ],
    [
      'E','B','Fs','Df'
    ],
    [
      'F','C','G','D'
    ],
    [
      'Fs','Df','Af','Ef'
    ],
    [
      'G','D','A','E'
    ],
    [
      'Af','Ef','Bf','F'
    ],
    [
      'A','E','B','Fs'
    ],
    [
      'Bf','F','C','G'
    ],
    [
      'B','Fs','Df','Af'
    ],
    [
      'C','G','D','A'
    ],
    [
      'Df','Af','Ef','Bf'
    ],
    [
      'D','A','E','B'
    ],
    [
      'Ef','Bf','F','C'
    ],
    [
      'E','B','Fs','Df'
    ],
    [
      'F','C','G','D'
    ],
    [
      'Fs','Df','Af','Ef'
    ],
    [
      'G','D','A','E'
    ],
];
const patternsCorrespondances = {
  up:[
    [
    'C',
    'G',
    'D',
    'A',
    'E',
    'B',
    'Fs'
    ],
    [
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F',
    'C',
    'G'
    ],
    [
    'D',
    'A',
    'E',
    'B',
    'Fs',
    'Df',
    'Af'
    ],
    [
    'Ef',
    'Bf',
    'F',
    'C',
    'G',
    'D',
    'A'
    ],
    [
    'E',
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf'
    ],
    [
    'F',
    'C',
    'G',
    'D',
    'A',
    'E',
    'B'
    ],
    [
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F',
    'C'
    ],
    [
    'G',
    'D',
    'A',
    'E',
    'B',
    'Fs',
    'Df'
    ],
    [
    'Af',
    'Ef',
    'Bf',
    'F',
    'C',
    'G',
    'D'
    ],
    [
    'A',
    'E',
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef'
    ],
    [
    'Bf',
    'F',
    'C',
    'G',
    'D',
    'A',
    'E'
    ],
    [
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F'
    ],
  ],
middle:[
    
    [
    'F',
    'C',
    'G',
    'D',
    'A',
    'E',
    'B'
    ],
    [
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F',
    'C'
    ],
    [
    'G',
    'D',
    'A',
    'E',
    'B',
    'Fs',
    'Df'
    ],
    [
    'Af',
    'Ef',
    'Bf',
    'F',
    'C',
    'G',
    'D'
    ],
    [
    'A',
    'E',
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef'
    ],
    [
    'Bf',
    'F',
    'C',
    'G',
    'D',
    'A',
    'E'
    ],
    [
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F'
    ],
    [
    'C',
    'G',
    'D',
    'A',
    'E',
    'B',
    'Fs'
    ],
    [
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F',
    'C',
    'G'
    ],
    [
    'D',
    'A',
    'E',
    'B',
    'Fs',
    'Df',
    'Af'
    ],
    [
    'Ef',
    'Bf',
    'F',
    'C',
    'G',
    'D',
    'A'
    ],
    [
    'E',
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf'
    ],
  ],
  low:[
    
    [
    'Bf',
    'F',
    'C',
    'G',
    'D',
    'A',
    'E'
    ],
    [
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F'
    ],[
    'C',
    'G',
    'D',
    'A',
    'E',
    'B',
    'Fs'
    ],
    [
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F',
    'C',
    'G'
    ],
    [
    'D',
    'A',
    'E',
    'B',
    'Fs',
    'Df',
    'Af'
    ],
    [
    'Ef',
    'Bf',
    'F',
    'C',
    'G',
    'D',
    'A'
    ],
    [
    'E',
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf'
    ],
    [
    'F',
    'C',
    'G',
    'D',
    'A',
    'E',
    'B'
    ],
    [
    'Fs',
    'Df',
    'Af',
    'Ef',
    'Bf',
    'F',
    'C'
    ],
    [
    'G',
    'D',
    'A',
    'E',
    'B',
    'Fs',
    'Df'
    ],
    [
    'Af',
    'Ef',
    'Bf',
    'F',
    'C',
    'G',
    'D'
    ],
    [
    'A',
    'E',
    'B',
    'Fs',
    'Df',
    'Af',
    'Ef'
    ],
  ],
}
const patternsList = {
  foDAE:[
    [
      ['s3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s2 n1 f1','s2 n3 f2','s2 n5 f1', 's2 n7 f2', 's1 n6 f3', 's1 n8 f4', 's1 n10 f3', 's1 n12 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4',
      's2 n1 f1','s2 n3 f2','s2 n5 f1', 's2 n7 f2', 's1 n6 f3', 's1 n8 f4', 's1 n10 f3', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s2 n2 f1','s2 n3 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n8 f4', 's1 n10 f3', 's1 n12 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4',
      's2 n2 f1','s2 n3 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n8 f4', 's1 n10 f3', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s2 n2 f1','s2 n3 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n8 f4', 's1 n10 f3', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4',
      's2 n2 f1','s2 n3 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n8 f4', 's1 n10 f3', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n10 f3', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4',
      's2 n2 f1','s2 n4 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n10 f3', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n10 f3', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4',
      's2 n2 f1','s2 n4 f2','s2 n5 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n10 f3', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n11 f3', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4',
      's2 n2 f1','s2 n4 f2','s2 n6 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n11 f3', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n8 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n13 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n11 f3', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n8 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n13 f4',
      's2 n2 f1','s2 n4 f2','s2 n6 f1', 's2 n7 f2', 's1 n7 f3', 's1 n9 f4', 's1 n11 f3', 's1 n12 f4'],
    ],
    
    
  ],
  foGDA:[
    [
      ['s4 n2 f1','s4 n3 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n8 f4', 's3 n10 f3', 's3 n12 f4'],
      ['s3 n1 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n6 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s4 n2 f1','s4 n3 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n8 f4', 's3 n10 f3', 's3 n12 f4',
      's3 n1 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n6 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n3 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n8 f4', 's3 n10 f3', 's3 n12 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s4 n2 f1','s4 n3 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n8 f4', 's3 n10 f3', 's3 n12 f4',
      's3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n10 f3', 's3 n12 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n10 f3', 's3 n12 f4',
      's3 n2 f1','s3 n3 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n8 f4', 's2 n10 f3', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n10 f3', 's3 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n5 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n10 f3', 's3 n12 f4',
      's3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n6 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n11 f3', 's3 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n11 f3', 's3 n12 f4',
      's3 n2 f1','s3 n4 f2','s3 n5 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n10 f3', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n6 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n11 f3', 's3 n12 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f1', 's4 n7 f2', 's3 n7 f3', 's3 n9 f4', 's3 n11 f3', 's3 n12 f4',
      's3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n6 f1', 's4 n8 f2', 's3 n7 f3', 's3 n9 f4', 's3 n11 f3', 's3 n13 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f1', 's4 n8 f2', 's3 n7 f3', 's3 n9 f4', 's3 n11 f3', 's3 n13 f4',
      's3 n2 f1','s3 n4 f2','s3 n6 f1', 's3 n7 f2', 's2 n7 f3', 's2 n9 f4', 's2 n11 f3', 's2 n12 f4'],
    ],
    
    
  ],
    oDAE:[
    [
      ['s3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s2 n1 f1','s2 n3 f1','s2 n5 f1', 's2 n7 f1', 's1 n6 f4', 's1 n8 f4', 's1 n10 f4', 's1 n12 f4'],
      ['s3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4',
      's2 n1 f1','s2 n3 f1','s2 n5 f1', 's2 n7 f1', 's1 n6 f4', 's1 n8 f4', 's1 n10 f4', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s2 n2 f1','s2 n3 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n8 f4', 's1 n10 f4', 's1 n12 f4'],
      ['s3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4',
      's2 n2 f1','s2 n3 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n8 f4', 's1 n10 f4', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s2 n2 f1','s2 n3 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n8 f4', 's1 n10 f4', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4',
      's2 n2 f1','s2 n3 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n8 f4', 's1 n10 f4', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s2 n2 f1','s2 n4 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n10 f4', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4',
      's2 n2 f1','s2 n4 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n10 f4', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4'],
      ['s2 n2 f1','s2 n4 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n10 f4', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4',
      's2 n2 f1','s2 n4 f1','s2 n5 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n10 f4', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4'],
      ['s2 n2 f1','s2 n4 f1','s2 n6 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n11 f4', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4',
      's2 n2 f1','s2 n4 f1','s2 n6 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n11 f4', 's1 n12 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n8 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n13 f4'],
      ['s2 n2 f1','s2 n4 f1','s2 n6 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n11 f4', 's1 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n8 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n13 f4',
      's2 n2 f1','s2 n4 f1','s2 n6 f1', 's2 n7 f1', 's1 n7 f4', 's1 n9 f4', 's1 n11 f4', 's1 n12 f4'],
    ],
    
    
  ],
  oGDA:[
    [
      ['s4 n2 f1','s4 n3 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n8 f4', 's3 n10 f4', 's3 n12 f4'],
      ['s3 n1 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n6 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s4 n2 f1','s4 n3 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n8 f4', 's3 n10 f4', 's3 n12 f4',
      's3 n1 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n6 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n3 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n8 f4', 's3 n10 f4', 's3 n12 f4'],
      ['s3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s4 n2 f1','s4 n3 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n8 f4', 's3 n10 f4', 's3 n12 f4',
      's3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n10 f4', 's3 n12 f4'],
      ['s3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n10 f4', 's3 n12 f4',
      's3 n2 f1','s3 n3 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n8 f4', 's2 n10 f4', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n10 f4', 's3 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f1','s4 n5 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n10 f4', 's3 n12 f4',
      's3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f1','s4 n6 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n11 f4', 's3 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f1','s4 n6 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n11 f4', 's3 n12 f4',
      's3 n2 f1','s3 n4 f1','s3 n5 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n10 f4', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f1','s4 n6 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n11 f4', 's3 n12 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f1','s4 n6 f1', 's4 n7 f1', 's3 n7 f4', 's3 n9 f4', 's3 n11 f4', 's3 n12 f4',
      's3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f1','s4 n6 f1', 's4 n8 f1', 's3 n7 f4', 's3 n9 f4', 's3 n11 f4', 's3 n13 f4'],
      ['s3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4'],
      ['s4 n2 f1','s4 n4 f1','s4 n6 f1', 's4 n8 f1', 's3 n7 f4', 's3 n9 f4', 's3 n11 f4', 's3 n13 f4',
      's3 n2 f1','s3 n4 f1','s3 n6 f1', 's3 n7 f1', 's2 n7 f4', 's2 n9 f4', 's2 n11 f4', 's2 n12 f4'],
    ],
    
    
  ],tDAE:[
    [
      ['s3 n5 f3','s2 n1 f1','s3 n7 f4', 's2 n3 f2', 's3 n8 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
      ['s2 n5 f3','s1 n1 f1','s2 n7 f4', 's1 n3 f2', 's2 n8 f3', 's1 n5 f1', 's2 n10 f4', 's1 n6 f2'],
      ['s3 n5 f3','s2 n1 f1','s3 n7 f4', 's2 n3 f2', 's3 n8 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2',
      's2 n5 f3','s1 n1 f1','s2 n7 f4', 's1 n3 f2', 's2 n8 f3', 's1 n5 f1', 's2 n10 f4', 's1 n6 f2'],
    ],[
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
      ['s2 n5 f3','s1 n1 f1','s2 n7 f4', 's1 n3 f2', 's2 n8 f3', 's1 n5 f1', 's2 n10 f4', 's1 n7 f2'],
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2',
      's2 n5 f3','s1 n1 f1','s2 n7 f4', 's1 n3 f2', 's2 n8 f3', 's1 n5 f1', 's2 n10 f4', 's1 n7 f2'],
    ],[
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
      ['s2 n5 f3','s1 n2 f1','s2 n7 f4', 's1 n3 f2', 's2 n9 f3', 's1 n5 f1', 's2 n10 f4', 's1 n7 f2'],
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2',
      's2 n5 f3','s1 n2 f1','s2 n7 f4', 's1 n3 f2', 's2 n9 f3', 's1 n5 f1', 's2 n10 f4', 's1 n7 f2'],
    ],[
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2'],
      ['s2 n5 f3','s1 n2 f1','s2 n7 f4', 's1 n3 f2', 's2 n9 f3', 's1 n5 f1', 's2 n10 f4', 's1 n7 f2'],
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2',
      's2 n5 f3','s1 n2 f1','s2 n7 f4', 's1 n3 f2', 's2 n9 f3', 's1 n5 f1', 's2 n10 f4', 's1 n7 f2'],
    ],[
      ['s3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2'],
      ['s2 n5 f3','s1 n2 f1','s2 n7 f4', 's1 n4 f2', 's2 n9 f3', 's1 n5 f1', 's2 n11 f4', 's1 n7 f2'],
      ['s3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2',
      's2 n5 f3','s1 n2 f1','s2 n7 f4', 's1 n4 f2', 's2 n9 f3', 's1 n5 f1', 's2 n11 f4', 's1 n7 f2'],
    ],[
      ['s3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n6 f1', 's3 n11 f4', 's2 n7 f2'],
      ['s2 n6 f3','s1 n2 f1','s2 n7 f4', 's1 n4 f2', 's2 n9 f3', 's1 n5 f1', 's2 n11 f4', 's1 n7 f2'],
      ['s3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n6 f1', 's3 n11 f4', 's2 n7 f2',
      's2 n6 f3','s1 n2 f1','s2 n7 f4', 's1 n4 f2', 's2 n9 f3', 's1 n5 f1', 's2 n11 f4', 's1 n7 f2'],
    ],[
      ['s3 n6 f3','s2 n2 f1','s3 n8 f4', 's2 n4 f2', 's3 n9 f3', 's2 n6 f1', 's3 n11 f4', 's2 n7 f2'],
      ['s2 n6 f3','s1 n2 f1','s2 n7 f4', 's1 n4 f2', 's2 n9 f3', 's1 n6 f1', 's2 n11 f4', 's1 n7 f2'],
      ['s3 n6 f3','s2 n2 f1','s3 n8 f4', 's2 n4 f2', 's3 n9 f3', 's2 n6 f1', 's3 n11 f4', 's2 n7 f2',
      's2 n6 f3','s1 n2 f1','s2 n7 f4', 's1 n4 f2', 's2 n9 f3', 's1 n6 f1', 's2 n11 f4', 's1 n7 f2'],
    ],
    
    
  ],
  tGDA:[
    [
      ['s4 n5 f3','s3 n1 f1','s4 n7 f4', 's3 n3 f2', 's4 n8 f3', 's3 n5 f1', 's4 n10 f4', 's3 n7 f2'],
      ['s3 n5 f3','s2 n1 f1','s3 n7 f4', 's2 n3 f2', 's3 n8 f3', 's2 n5 f1', 's3 n10 f4', 's2 n6 f2'],
      ['s4 n5 f3','s3 n1 f1','s4 n7 f4', 's3 n3 f2', 's4 n8 f3', 's3 n5 f1', 's4 n10 f4', 's3 n7 f2',
      's3 n5 f3','s2 n1 f1','s3 n7 f4', 's2 n3 f2', 's3 n8 f3', 's2 n5 f1', 's3 n10 f4', 's2 n6 f2'],
    ],[
      ['s4 n5 f3','s3 n2 f1','s4 n7 f4', 's3 n3 f2', 's4 n9 f3', 's3 n5 f1', 's4 n10 f4', 's3 n7 f2'],
      ['s3 n5 f3','s2 n1 f1','s3 n7 f4', 's2 n3 f2', 's3 n8 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
      ['s4 n5 f3','s3 n2 f1','s4 n7 f4', 's3 n3 f2', 's4 n9 f3', 's3 n5 f1', 's4 n10 f4', 's3 n7 f2',
      's3 n5 f3','s2 n1 f1','s3 n7 f4', 's2 n3 f2', 's3 n8 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
    ],[
      ['s4 n5 f3','s3 n2 f1','s4 n7 f4', 's3 n3 f2', 's4 n9 f3', 's3 n5 f1', 's4 n10 f4', 's3 n7 f2'],
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
      ['s4 n5 f3','s3 n2 f1','s4 n7 f4', 's3 n3 f2', 's4 n9 f3', 's3 n5 f1', 's4 n10 f4', 's3 n7 f2',
      's3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
    ],[
      ['s4 n5 f3','s3 n2 f1','s4 n7 f4', 's3 n4 f2', 's4 n9 f3', 's3 n5 f1', 's4 n11 f4', 's3 n7 f2'],
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
      ['s4 n5 f3','s3 n2 f1','s4 n7 f4', 's3 n4 f2', 's4 n9 f3', 's3 n5 f1', 's4 n11 f4', 's3 n7 f2',
      's3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n3 f2', 's3 n9 f3', 's2 n5 f1', 's3 n10 f4', 's2 n7 f2'],
    ],[
      ['s4 n6 f3','s3 n2 f1','s4 n7 f4', 's3 n4 f2', 's4 n9 f3', 's3 n5 f1', 's4 n11 f4', 's3 n7 f2'],
      ['s3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2'],
      ['s4 n6 f3','s3 n2 f1','s4 n7 f4', 's3 n4 f2', 's4 n9 f3', 's3 n5 f1', 's4 n11 f4', 's3 n7 f2',
      's3 n5 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2'],
    ],[
      ['s4 n6 f3','s3 n2 f1','s4 n7 f4', 's3 n4 f2', 's4 n9 f3', 's3 n6 f1', 's4 n11 f4', 's3 n7 f2'],
      ['s3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2'],
      ['s4 n6 f3','s3 n2 f1','s4 n7 f4', 's3 n4 f2', 's4 n9 f3', 's3 n6 f1', 's4 n11 f4', 's3 n7 f2',
      's3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n5 f1', 's3 n11 f4', 's2 n7 f2'],
    ],[
      ['s4 n6 f3','s3 n2 f1','s4 n8 f4', 's3 n4 f2', 's4 n9 f3', 's3 n6 f1', 's4 n11 f4', 's3 n7 f2'],
      ['s3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n6 f1', 's3 n11 f4', 's2 n7 f2'],
      ['s4 n6 f3','s3 n2 f1','s4 n8 f4', 's3 n4 f2', 's4 n9 f3', 's3 n6 f1', 's4 n11 f4', 's3 n7 f2',
      's3 n6 f3','s2 n2 f1','s3 n7 f4', 's2 n4 f2', 's3 n9 f3', 's2 n6 f1', 's3 n11 f4', 's2 n7 f2'],
    ],
    
    
  ],
  seAE:[
    [
      ['s2 n2 f1','s2 n3 f2','s2 n5 f2', 's2 n7 f3', 's2 n8 f3', 's2 n10 f4'],
      [ 's1 n1 f1','s1 n3 f2', 's1 n5 f2', 's1 n7 f3', 's1 n8 f3', 's1 n10 f4'],
      ['s2 n2 f1','s2 n3 f2','s2 n5 f2', 's2 n7 f3', 's2 n8 f3', 's2 n10 f4',
      's1 n1 f1','s1 n3 f2', 's1 n5 f2', 's1 n7 f3', 's1 n8 f3', 's1 n10 f4'],
    ],
    [
      ['s2 n2 f1','s2 n3 f2','s2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4'],
      [ 's1 n2 f1','s1 n3 f2', 's1 n5 f2', 's1 n7 f3', 's1 n8 f3', 's1 n10 f4'],
      ['s2 n2 f1','s2 n3 f2','s2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4',
        's1 n2 f1','s1 n3 f2', 's1 n5 f2', 's1 n7 f3', 's1 n8 f3', 's1 n10 f4']
    ],[
      ['s2 n2 f1','s2 n4 f2','s2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4'],
      [ 's1 n2 f1','s1 n3 f2', 's1 n5 f2', 's1 n7 f3', 's1 n9 f3', 's1 n10 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4',
        's1 n2 f1','s1 n3 f2', 's1 n5 f2', 's1 n7 f3', 's1 n9 f3', 's1 n10 f4']
    ],[
      ['s2 n2 f1','s2 n4 f2','s2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n5 f2', 's1 n7 f3', 's1 n9 f3', 's1 n10 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4',
        's1 n2 f1','s1 n4 f2', 's1 n5 f2', 's1 n7 f3', 's1 n9 f3', 's1 n10 f4']
    ],[
      ['s2 n2 f1','s2 n4 f2','s2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n5 f2', 's1 n7 f3', 's1 n9 f3', 's1 n11 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4',
        's1 n2 f1','s1 n4 f2', 's1 n5 f2', 's1 n7 f3', 's1 n9 f3', 's1 n11 f4']
    ],[
      ['s2 n2 f1','s2 n4 f2','s2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n6 f2', 's1 n7 f3', 's1 n9 f3', 's1 n11 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4',
        's1 n2 f1','s1 n4 f2', 's1 n6 f2', 's1 n7 f3', 's1 n9 f3', 's1 n11 f4']
    ],[
      ['s2 n2 f1','s2 n4 f2','s2 n6 f2', 's2 n8 f3', 's2 n9 f3', 's2 n11 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n6 f2', 's1 n7 f3', 's1 n9 f3', 's1 n11 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f2', 's2 n8 f3', 's2 n9 f3', 's2 n11 f4',
        's1 n2 f1','s1 n4 f2', 's1 n6 f2', 's1 n7 f3', 's1 n9 f3', 's1 n11 f4']
    ]
    
  ],seAD:[
      [
      ['s3 n2 f1','s3 n3 f2','s3 n5 f2', 's3 n7 f3', 's3 n8 f3', 's3 n10 f4'],
      [ 's2 n1 f1','s2 n3 f2', 's2 n5 f2', 's2 n7 f3', 's2 n8 f3', 's2 n10 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f2', 's3 n7 f3', 's3 n8 f3', 's3 n10 f4',
      's2 n1 f1','s2 n3 f2', 's2 n5 f2', 's2 n7 f3', 's2 n8 f3', 's2 n10 f4'],
    ],
    [
      ['s3 n2 f1','s3 n3 f2','s3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4'],
      [ 's2 n2 f1','s2 n3 f2', 's2 n5 f2', 's2 n7 f3', 's2 n8 f3', 's2 n10 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4',
        's2 n2 f1','s2 n3 f2', 's2 n5 f2', 's2 n7 f3', 's2 n8 f3', 's2 n10 f4']
    ],[
      ['s3 n2 f1','s3 n4 f2','s3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4'],
      [ 's2 n2 f1','s2 n3 f2', 's2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4',
        's2 n2 f1','s2 n3 f2', 's2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4']
    ],[
      ['s3 n2 f1','s3 n4 f2','s3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4',
        's2 n2 f1','s2 n4 f2', 's2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n10 f4']
    ],[
      ['s3 n2 f1','s3 n4 f2','s3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4',
        's2 n2 f1','s2 n4 f2', 's2 n5 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4']
    ],[
      ['s3 n2 f1','s3 n4 f2','s3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4',
        's2 n2 f1','s2 n4 f2', 's2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4']
    ],[
      ['s3 n2 f1','s3 n4 f2','s3 n6 f2', 's3 n8 f3', 's3 n9 f3', 's3 n11 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f2', 's3 n8 f3', 's3 n9 f3', 's3 n11 f4',
        's2 n2 f1','s2 n4 f2', 's2 n6 f2', 's2 n7 f3', 's2 n9 f3', 's2 n11 f4']
    ]
    
  ],
  seGD:[
      [
      ['s4 n2 f1','s4 n3 f2','s4 n5 f2', 's4 n7 f3', 's4 n8 f3', 's4 n10 f4'],
      [ 's3 n1 f1','s3 n3 f2', 's3 n5 f2', 's3 n7 f3', 's3 n8 f3', 's3 n10 f4'],
      ['s4 n2 f1','s4 n3 f2','s4 n5 f2', 's4 n7 f3', 's4 n8 f3', 's4 n10 f4',
      's3 n1 f1','s3 n3 f2', 's3 n5 f2', 's3 n7 f3', 's3 n8 f3', 's3 n10 f4'],
    ],
    [
      ['s4 n2 f1','s4 n3 f2','s4 n5 f2', 's4 n7 f3', 's4 n9 f3', 's4 n10 f4'],
      [ 's3 n2 f1','s3 n3 f2', 's3 n5 f2', 's3 n7 f3', 's3 n8 f3', 's3 n10 f4'],
      ['s4 n2 f1','s4 n3 f2','s4 n5 f2', 's4 n7 f3', 's4 n9 f3', 's4 n10 f4',
        's3 n2 f1','s3 n3 f2', 's3 n5 f2', 's3 n7 f3', 's3 n8 f3', 's3 n10 f4']
    ],[
      ['s4 n2 f1','s4 n4 f2','s4 n5 f2', 's4 n7 f3', 's4 n9 f3', 's4 n10 f4'],
      [ 's3 n2 f1','s3 n3 f2', 's3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n5 f2', 's4 n7 f3', 's4 n9 f3', 's4 n10 f4',
        's3 n2 f1','s3 n3 f2', 's3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4']
    ],[
      ['s4 n2 f1','s4 n4 f2','s4 n5 f2', 's4 n7 f3', 's4 n9 f3', 's4 n11 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n5 f2', 's4 n7 f3', 's4 n9 f3', 's4 n11 f4',
        's3 n2 f1','s3 n4 f2', 's3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n10 f4']
    ],[
      ['s4 n2 f1','s4 n4 f2','s4 n6 f2', 's4 n7 f3', 's4 n9 f3', 's4 n11 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f2', 's4 n7 f3', 's4 n9 f3', 's4 n11 f4',
        's3 n2 f1','s3 n4 f2', 's3 n5 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4']
    ],[
      ['s4 n2 f1','s4 n4 f2','s4 n6 f2', 's4 n7 f3', 's4 n9 f3', 's4 n11 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f2', 's4 n7 f3', 's4 n9 f3', 's4 n11 f4',
        's3 n2 f1','s3 n4 f2', 's3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4']
    ],[
      ['s4 n2 f1','s4 n4 f2','s4 n6 f2', 's4 n8 f3', 's4 n9 f3', 's4 n11 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f2', 's4 n8 f3', 's4 n9 f3', 's4 n11 f4',
        's3 n2 f1','s3 n4 f2', 's3 n6 f2', 's3 n7 f3', 's3 n9 f3', 's3 n11 f4']
    ]
    
  ],
  sAE:[
    [
      ['s2 n2 f1','s2 n3 f2','s2 n5 f3', 's2 n7 f4'],
      [ 's1 n1 f1','s1 n3 f2', 's1 n5 f3', 's1 n7 f4'],
      ['s2 n2 f1','s2 n3 f2','s2 n5 f3', 's2 n7 f4', 
        's1 n1 f1','s1 n3 f2', 's1 n5 f3', 's1 n7 f4'],
    ],
    [
      ['s2 n2 f1','s2 n3 f2','s2 n5 f3', 's2 n7 f4'],
      [ 's1 n2 f1','s1 n3 f2', 's1 n5 f3', 's1 n7 f4'],
      ['s2 n2 f1','s2 n3 f2','s2 n5 f3', 's2 n7 f4', 
        's1 n2 f1','s1 n3 f2', 's1 n5 f3', 's1 n7 f4'],
    ],
    [
      ['s2 n2 f1','s2 n4 f2','s2 n5 f3', 's2 n7 f4'],
      [ 's1 n2 f1','s1 n3 f2', 's1 n5 f3', 's1 n7 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n5 f3', 's2 n7 f4', 
        's1 n2 f1','s1 n3 f2', 's1 n5 f3', 's1 n7 f4'],
    ],
    [
      ['s2 n2 f1','s2 n4 f2','s2 n5 f3', 's2 n7 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n5 f3', 's1 n7 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n5 f3', 's2 n7 f4', 
        's1 n2 f1','s1 n4 f2', 's1 n5 f3', 's1 n7 f4'],
    ],
    [
      ['s2 n2 f1','s2 n4 f2','s2 n6 f3', 's2 n7 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n5 f3', 's1 n7 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f3', 's2 n7 f4', 
        's1 n2 f1','s1 n4 f2', 's1 n5 f3', 's1 n7 f4'],
    ],
    [
      ['s2 n2 f1','s2 n4 f2','s2 n6 f3', 's2 n7 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n6 f3', 's1 n7 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f3', 's2 n7 f4', 
        's1 n2 f1','s1 n4 f2', 's1 n6 f3', 's1 n7 f4'],
    ],
    [
      ['s2 n2 f1','s2 n4 f2','s2 n6 f3', 's2 n8 f4'],
      [ 's1 n2 f1','s1 n4 f2', 's1 n6 f3', 's1 n7 f4'],
      ['s2 n2 f1','s2 n4 f2','s2 n6 f3', 's2 n8 f4', 
        's1 n2 f1','s1 n4 f2', 's1 n6 f3', 's1 n7 f4'],
    ]
    
  ],sAD:[
    [
      ['s3 n2 f1','s3 n3 f2','s3 n5 f3', 's3 n7 f4'],
      [ 's2 n1 f1','s2 n3 f2', 's2 n5 f3', 's2 n7 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f3', 's3 n7 f4', 
        's2 n1 f1','s2 n3 f2', 's2 n5 f3', 's2 n7 f4'],
    ],
    [
      ['s3 n2 f1','s3 n3 f2','s3 n5 f3', 's3 n7 f4'],
      [ 's2 n2 f1','s2 n3 f2', 's2 n5 f3', 's2 n7 f4'],
      ['s3 n2 f1','s3 n3 f2','s3 n5 f3', 's3 n7 f4', 
        's2 n2 f1','s2 n3 f2', 's2 n5 f3', 's2 n7 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n5 f3', 's3 n7 f4'],
      [ 's2 n2 f1','s2 n3 f2', 's2 n5 f3', 's2 n7 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f3', 's3 n7 f4', 
        's2 n2 f1','s2 n3 f2', 's2 n5 f3', 's2 n7 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n5 f3', 's3 n7 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n5 f3', 's2 n7 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n5 f3', 's3 n7 f4', 
        's2 n2 f1','s2 n4 f2', 's2 n5 f3', 's2 n7 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n6 f3', 's3 n7 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n5 f3', 's2 n7 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f3', 's3 n7 f4', 
        's2 n2 f1','s2 n4 f2', 's2 n5 f3', 's2 n7 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n6 f3', 's3 n7 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n6 f3', 's2 n7 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f3', 's3 n7 f4', 
        's2 n2 f1','s2 n4 f2', 's2 n6 f3', 's2 n7 f4'],
    ],
    [
      ['s3 n2 f1','s3 n4 f2','s3 n6 f3', 's3 n8 f4'],
      [ 's2 n2 f1','s2 n4 f2', 's2 n6 f3', 's2 n7 f4'],
      ['s3 n2 f1','s3 n4 f2','s3 n6 f3', 's3 n8 f4', 
        's2 n2 f1','s2 n4 f2', 's2 n6 f3', 's2 n7 f4'],
    ]
    
  ],
  sGD:[
    [
      ['s4 n2 f1','s4 n3 f2','s4 n5 f3', 's4 n7 f4'],
      [ 's3 n1 f1','s3 n3 f2', 's3 n5 f3', 's3 n7 f4'],
      ['s4 n2 f1','s4 n3 f2','s4 n5 f3', 's4 n7 f4', 
        's3 n1 f1','s3 n3 f2', 's3 n5 f3', 's3 n7 f4'],
    ],
    [
      ['s4 n2 f1','s4 n3 f2','s4 n5 f3', 's4 n7 f4'],
      [ 's3 n2 f1','s3 n3 f2', 's3 n5 f3', 's3 n7 f4'],
      ['s4 n2 f1','s4 n3 f2','s4 n5 f3', 's4 n7 f4', 
        's3 n2 f1','s3 n3 f2', 's3 n5 f3', 's3 n7 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n5 f3', 's4 n7 f4'],
      [ 's3 n2 f1','s3 n3 f2', 's3 n5 f3', 's3 n7 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n5 f3', 's4 n7 f4', 
        's3 n2 f1','s3 n3 f2', 's3 n5 f3', 's3 n7 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n5 f3', 's4 n7 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n5 f3', 's3 n7 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n5 f3', 's4 n7 f4', 
        's3 n2 f1','s3 n4 f2', 's3 n5 f3', 's3 n7 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n6 f3', 's4 n7 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n5 f3', 's3 n7 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f3', 's4 n7 f4', 
        's3 n2 f1','s3 n4 f2', 's3 n5 f3', 's3 n7 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n6 f3', 's4 n7 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n6 f3', 's3 n7 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f3', 's4 n7 f4', 
        's3 n2 f1','s3 n4 f2', 's3 n6 f3', 's3 n7 f4'],
    ],
    [
      ['s4 n2 f1','s4 n4 f2','s4 n6 f3', 's4 n8 f4'],
      [ 's3 n2 f1','s3 n4 f2', 's3 n6 f3', 's3 n7 f4'],
      ['s4 n2 f1','s4 n4 f2','s4 n6 f3', 's4 n8 f4', 
        's3 n2 f1','s3 n4 f2', 's3 n6 f3', 's3 n7 f4'],
    ]
    
  ],
  AE:[
  [
    ['s1 n1 f1','s1 n3 f3','s2 n2 f2'],
    ['s1 n1 f1','s1 n5 f4','s2 n2 f2'],
    ['s1 n1 f1','s1 n5 f3','s2 n2 f2'],
    ['s1 n1 f1','s1 n7 f4','s2 n2 f2'],

    ['s1 n3 f2','s1 n5 f3','s2 n2 f1'],
    ['s1 n3 f2','s1 n7 f4','s2 n2 f1'],
    ['s1 n5 f3','s1 n7 f4','s2 n2 f1'],

    ['s1 n1 f1','s1 n3 f2','s2 n3 f2'],
    ['s1 n1 f1','s1 n5 f3','s2 n3 f2'],
    ['s1 n1 f1','s1 n7 f4','s2 n3 f2'],

    ['s1 n3 f2','s1 n5 f3','s2 n3 f2'],
    ['s1 n3 f2','s1 n7 f4','s2 n3 f2'],
    ['s1 n5 f3','s1 n7 f4','s2 n3 f2'],

    ['s1 n1 f1','s1 n3 f2','s2 n5 f3'],
    ['s1 n1 f1','s1 n5 f3','s2 n5 f3'],
    ['s1 n1 f1','s1 n7 f4','s2 n5 f3'],

    ['s1 n3 f2','s1 n5 f3','s2 n5 f3'],
    ['s1 n3 f2','s1 n7 f4','s2 n5 f3'],
    ['s1 n5 f3','s1 n7 f4','s2 n5 f3'],

    ['s1 n1 f1','s1 n3 f2','s2 n7 f4'],
    ['s1 n1 f1','s1 n5 f3','s2 n7 f4'],
    ['s1 n1 f1','s1 n7 f4','s2 n7 f4'],

    ['s1 n3 f2','s1 n5 f3','s2 n7 f4'],
    ['s1 n3 f2','s1 n7 f4','s2 n7 f4'],
    ['s1 n5 f3','s1 n7 f4','s2 n7 f4'],



    ['s2 n2 f2','s2 n3 f3','s1 n1 f1'],
    ['s2 n2 f2','s2 n5 f4','s1 n1 f1'],
    ['s2 n2 f2','s2 n5 f3','s1 n1 f1'],
    ['s2 n2 f2','s2 n7 f4','s1 n1 f1'],

    ['s2 n3 f2','s2 n5 f3','s1 n1 f1'],
    ['s2 n3 f2','s2 n7 f4','s1 n1 f1'],
    ['s2 n5 f3','s2 n7 f4','s1 n1 f1'],

    ['s2 n2 f1','s2 n3 f2','s1 n3 f2'],
    ['s2 n2 f1','s2 n5 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n7 f4','s1 n3 f2'],

    ['s2 n3 f2','s2 n5 f3','s1 n3 f2'],
    ['s2 n3 f2','s2 n7 f4','s1 n3 f2'],
    ['s2 n5 f3','s2 n7 f4','s1 n3 f2'],

    ['s2 n2 f1','s2 n3 f2','s1 n5 f3'],
    ['s2 n2 f1','s2 n5 f3','s1 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s1 n5 f3'],

    ['s2 n3 f2','s2 n5 f3','s1 n5 f3'],
    ['s2 n3 f2','s2 n7 f4','s1 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s1 n5 f3'],

    ['s2 n2 f1','s2 n3 f2','s1 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s1 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s1 n7 f4'],

    ['s2 n3 f2','s2 n5 f3','s1 n7 f4'],
    ['s2 n3 f2','s2 n7 f4','s1 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s1 n7 f4'],
  ],
  [
    ['s1 n2 f1','s1 n3 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n5 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f4','s2 n2 f1'],

    ['s1 n3 f2','s1 n5 f3','s2 n2 f1'],
    ['s1 n3 f2','s1 n7 f4','s2 n2 f1'],
    ['s1 n5 f3','s1 n7 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n3 f2','s2 n3 f2'],
    ['s1 n2 f1','s1 n5 f3','s2 n3 f2'],
    ['s1 n2 f1','s1 n7 f4','s2 n3 f2'],

    ['s1 n3 f2','s1 n5 f3','s2 n3 f2'],
    ['s1 n3 f2','s1 n7 f4','s2 n3 f2'],
    ['s1 n5 f3','s1 n7 f4','s2 n3 f2'],

    ['s1 n2 f1','s1 n3 f2','s2 n5 f3'],
    ['s1 n2 f1','s1 n5 f3','s2 n5 f3'],
    ['s1 n2 f1','s1 n7 f4','s2 n5 f3'],

    ['s1 n3 f2','s1 n5 f3','s2 n5 f3'],
    ['s1 n3 f2','s1 n7 f4','s2 n5 f3'],
    ['s1 n5 f3','s1 n7 f4','s2 n5 f3'],

    ['s1 n2 f1','s1 n3 f2','s2 n7 f4'],
    ['s1 n2 f1','s1 n5 f3','s2 n7 f4'],
    ['s1 n2 f1','s1 n7 f4','s2 n7 f4'],

    ['s1 n3 f2','s1 n5 f3','s2 n7 f4'],
    ['s1 n3 f2','s1 n7 f4','s2 n7 f4'],
    ['s1 n5 f3','s1 n7 f4','s2 n7 f4'],



    ['s2 n2 f1','s2 n3 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n5 f3','s1 n2 f1'],
    ['s2 n2 f2','s2 n7 f4','s1 n2 f1'],

    ['s2 n3 f2','s2 n5 f3','s1 n2 f1'],
    ['s2 n3 f2','s2 n7 f4','s1 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n3 f2','s1 n3 f2'],
    ['s2 n2 f1','s2 n5 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n7 f4','s1 n3 f2'],

    ['s2 n3 f2','s2 n5 f3','s1 n3 f2'],
    ['s2 n3 f2','s2 n7 f4','s1 n3 f2'],
    ['s2 n5 f3','s2 n7 f4','s1 n3 f2'],

    ['s2 n2 f1','s2 n3 f2','s1 n5 f3'],
    ['s2 n2 f1','s2 n5 f3','s1 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s1 n5 f3'],

    ['s2 n3 f2','s2 n5 f3','s1 n5 f3'],
    ['s2 n3 f2','s2 n7 f4','s1 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s1 n5 f3'],

    ['s2 n2 f1','s2 n3 f2','s1 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s1 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s1 n7 f4'],

    ['s2 n3 f2','s2 n5 f3','s1 n7 f4'],
    ['s2 n3 f2','s2 n7 f4','s1 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s1 n7 f4'],
  ],
  [
    ['s1 n2 f1','s1 n3 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n5 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f4','s2 n2 f1'],

    ['s1 n3 f2','s1 n5 f3','s2 n2 f1'],
    ['s1 n3 f2','s1 n7 f4','s2 n2 f1'],
    ['s1 n5 f3','s1 n7 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n3 f1','s2 n4 f2'],
    ['s1 n2 f1','s1 n5 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f4','s2 n4 f2'],

    ['s1 n3 f1','s1 n5 f3','s2 n4 f2'],
    ['s1 n3 f1','s1 n7 f4','s2 n4 f2'],
    ['s1 n5 f3','s1 n7 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n3 f2','s2 n5 f3'],
    ['s1 n2 f1','s1 n5 f3','s2 n5 f3'],
    ['s1 n2 f1','s1 n7 f4','s2 n5 f3'],

    ['s1 n3 f2','s1 n5 f3','s2 n5 f3'],
    ['s1 n3 f2','s1 n7 f4','s2 n5 f3'],
    ['s1 n5 f3','s1 n7 f4','s2 n5 f3'],

    ['s1 n2 f1','s1 n3 f2','s2 n7 f4'],
    ['s1 n2 f1','s1 n5 f3','s2 n7 f4'],
    ['s1 n2 f1','s1 n7 f4','s2 n7 f4'],

    ['s1 n3 f2','s1 n5 f3','s2 n7 f4'],
    ['s1 n3 f2','s1 n7 f4','s2 n7 f4'],
    ['s1 n5 f3','s1 n7 f4','s2 n7 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n5 f3','s1 n2 f1'],
    ['s2 n2 f2','s2 n7 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n5 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s1 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n5 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n7 f4','s1 n3 f2'],

    ['s2 n4 f3','s2 n5 f4','s1 n3 f2'],
    ['s2 n4 f3','s2 n5 f3','s1 n3 f2'],
    ['s2 n4 f3','s2 n7 f4','s1 n3 f2'],
    ['s2 n5 f3','s2 n7 f4','s1 n3 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n5 f3'],
    ['s2 n2 f1','s2 n5 f3','s1 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s1 n5 f3'],

    ['s2 n4 f2','s2 n5 f3','s1 n5 f3'],
    ['s2 n4 f2','s2 n7 f4','s1 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s1 n5 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s1 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s1 n7 f4'],

    ['s2 n4 f2','s2 n5 f3','s1 n7 f4'],
    ['s2 n4 f2','s2 n7 f4','s1 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s1 n7 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n5 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n5 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n7 f4','s2 n2 f1'],
    ['s1 n5 f3','s1 n7 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n5 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n5 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n7 f4','s2 n4 f2'],
    ['s1 n5 f3','s1 n7 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n5 f3'],
    ['s1 n2 f1','s1 n5 f3','s2 n5 f3'],
    ['s1 n2 f1','s1 n7 f4','s2 n5 f3'],

    ['s1 n4 f2','s1 n5 f3','s2 n5 f3'],
    ['s1 n4 f2','s1 n7 f4','s2 n5 f3'],
    ['s1 n5 f3','s1 n7 f4','s2 n5 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n7 f4'],
    ['s1 n2 f1','s1 n5 f3','s2 n7 f4'],
    ['s1 n2 f1','s1 n7 f4','s2 n7 f4'],

    ['s1 n4 f2','s1 n5 f3','s2 n7 f4'],
    ['s1 n4 f2','s1 n7 f4','s2 n7 f4'],
    ['s1 n5 f3','s1 n7 f4','s2 n7 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n5 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n5 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s1 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n5 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n5 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n7 f4','s1 n4 f2'],
    ['s2 n5 f3','s2 n7 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n5 f3'],
    ['s2 n2 f1','s2 n5 f3','s1 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s1 n5 f3'],

    ['s2 n4 f2','s2 n5 f3','s1 n5 f3'],
    ['s2 n4 f2','s2 n7 f4','s1 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s1 n5 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s1 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s1 n7 f4'],

    ['s2 n4 f2','s2 n5 f3','s1 n7 f4'],
    ['s2 n4 f2','s2 n7 f4','s1 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s1 n7 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n5 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n5 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n7 f4','s2 n2 f1'],
    ['s1 n5 f3','s1 n7 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n5 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n5 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n7 f4','s2 n4 f2'],
    ['s1 n5 f3','s1 n7 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n6 f3'],
    ['s1 n2 f1','s1 n5 f2','s2 n6 f3'],
    ['s1 n2 f1','s1 n7 f4','s2 n6 f3'],

    ['s1 n4 f2','s1 n5 f2','s2 n6 f3'],
    ['s1 n4 f2','s1 n7 f4','s2 n6 f3'],
    ['s1 n5 f2','s1 n7 f4','s2 n6 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n7 f4'],
    ['s1 n2 f1','s1 n5 f3','s2 n7 f4'],
    ['s1 n2 f1','s1 n7 f4','s2 n7 f4'],

    ['s1 n4 f2','s1 n5 f3','s2 n7 f4'],
    ['s1 n4 f2','s1 n7 f4','s2 n7 f4'],
    ['s1 n5 f3','s1 n7 f4','s2 n7 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n6 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n6 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s1 n2 f1'],
    ['s2 n6 f3','s2 n7 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n6 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n6 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n7 f4','s1 n4 f2'],
    ['s2 n6 f3','s2 n7 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n5 f3'],
    ['s2 n2 f1','s2 n6 f4','s1 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s1 n5 f3'],

    ['s2 n4 f2','s2 n6 f4','s1 n5 f3'],
    ['s2 n4 f2','s2 n7 f4','s1 n5 f3'],
    ['s2 n6 f4','s2 n7 f4','s1 n5 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f4'],
    ['s2 n2 f1','s2 n6 f3','s1 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s1 n7 f4'],

    ['s2 n4 f2','s2 n6 f3','s1 n7 f4'],
    ['s2 n4 f2','s2 n7 f4','s1 n7 f4'],
    ['s2 n6 f3','s2 n7 f4','s1 n7 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n6 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n6 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n7 f4','s2 n2 f1'],
    ['s1 n6 f3','s1 n7 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n6 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n6 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n7 f4','s2 n4 f2'],
    ['s1 n6 f3','s1 n7 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n6 f3'],
    ['s1 n2 f1','s1 n6 f3','s2 n6 f3'],
    ['s1 n2 f1','s1 n7 f4','s2 n6 f3'],

    ['s1 n4 f2','s1 n6 f3','s2 n6 f3'],
    ['s1 n4 f2','s1 n7 f4','s2 n6 f3'],
    ['s1 n6 f3','s1 n7 f4','s2 n6 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n7 f4'],
    ['s1 n2 f1','s1 n6 f3','s2 n7 f4'],
    ['s1 n2 f1','s1 n7 f4','s2 n7 f4'],

    ['s1 n4 f2','s1 n6 f3','s2 n7 f4'],
    ['s1 n4 f2','s1 n7 f4','s2 n7 f4'],
    ['s1 n6 f3','s1 n7 f4','s2 n7 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n6 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n6 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s1 n2 f1'],
    ['s2 n6 f3','s2 n7 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n6 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n6 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n7 f4','s1 n4 f2'],
    ['s2 n6 f3','s2 n7 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n6 f3'],
    ['s2 n2 f1','s2 n6 f3','s1 n6 f3'],
    ['s2 n2 f1','s2 n7 f4','s1 n6 f3'],

    ['s2 n4 f2','s2 n6 f3','s1 n6 f3'],
    ['s2 n4 f2','s2 n7 f4','s1 n6 f3'],
    ['s2 n6 f3','s2 n7 f4','s1 n6 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f4'],
    ['s2 n2 f1','s2 n6 f3','s1 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s1 n7 f4'],

    ['s2 n4 f2','s2 n6 f3','s1 n7 f4'],
    ['s2 n4 f2','s2 n7 f4','s1 n7 f4'],
    ['s2 n6 f3','s2 n7 f4','s1 n7 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n6 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n6 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n7 f4','s2 n2 f1'],
    ['s1 n6 f3','s1 n7 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n6 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n6 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n7 f4','s2 n4 f2'],
    ['s1 n6 f3','s1 n7 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n6 f3'],
    ['s1 n2 f1','s1 n6 f3','s2 n6 f3'],
    ['s1 n2 f1','s1 n7 f4','s2 n6 f3'],

    ['s1 n4 f2','s1 n6 f3','s2 n6 f3'],
    ['s1 n4 f2','s1 n7 f4','s2 n6 f3'],
    ['s1 n6 f3','s1 n7 f4','s2 n6 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n8 f4'],
    ['s1 n2 f1','s1 n6 f3','s2 n8 f4'],
    ['s1 n2 f1','s1 n7 f3','s2 n8 f4'],

    ['s1 n4 f2','s1 n6 f3','s2 n8 f4'],
    ['s1 n4 f2','s1 n7 f3','s2 n8 f4'],
    ['s1 n6 f3','s1 n7 f3','s2 n8 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n6 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n8 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n6 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n8 f4','s1 n2 f1'],
    ['s2 n6 f3','s2 n8 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n6 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n8 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n6 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n8 f4','s1 n4 f2'],
    ['s2 n6 f3','s2 n8 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n6 f3'],
    ['s2 n2 f1','s2 n6 f3','s1 n6 f3'],
    ['s2 n2 f1','s2 n8 f4','s1 n6 f3'],

    ['s2 n4 f2','s2 n6 f3','s1 n6 f3'],
    ['s2 n4 f2','s2 n8 f4','s1 n6 f3'],
    ['s2 n6 f3','s2 n8 f4','s1 n6 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n6 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n8 f4','s1 n7 f3'],

    ['s2 n4 f2','s2 n6 f2','s1 n7 f3'],
    ['s2 n4 f2','s2 n8 f4','s1 n7 f3'],
    ['s2 n6 f2','s2 n8 f4','s1 n7 f3'],
  ]
],
AD:[
  [
    ['s2 n1 f1','s2 n3 f3','s3 n2 f2'],
    ['s2 n1 f1','s2 n5 f4','s3 n2 f2'],
    ['s2 n1 f1','s2 n5 f3','s3 n2 f2'],
    ['s2 n1 f1','s2 n7 f4','s3 n2 f2'],

    ['s2 n3 f2','s2 n5 f3','s3 n2 f1'],
    ['s2 n3 f2','s2 n7 f4','s3 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s3 n2 f1'],

    ['s2 n1 f1','s2 n3 f2','s3 n3 f2'],
    ['s2 n1 f1','s2 n5 f3','s3 n3 f2'],
    ['s2 n1 f1','s2 n7 f4','s3 n3 f2'],

    ['s2 n3 f2','s2 n5 f3','s3 n3 f2'],
    ['s2 n3 f2','s2 n7 f4','s3 n3 f2'],
    ['s2 n5 f3','s2 n7 f4','s3 n3 f2'],

    ['s2 n1 f1','s2 n3 f2','s3 n5 f3'],
    ['s2 n1 f1','s2 n5 f3','s3 n5 f3'],
    ['s2 n1 f1','s2 n7 f4','s3 n5 f3'],

    ['s2 n3 f2','s2 n5 f3','s3 n5 f3'],
    ['s2 n3 f2','s2 n7 f4','s3 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s3 n5 f3'],

    ['s2 n1 f1','s2 n3 f2','s3 n7 f4'],
    ['s2 n1 f1','s2 n5 f3','s3 n7 f4'],
    ['s2 n1 f1','s2 n7 f4','s3 n7 f4'],

    ['s2 n3 f2','s2 n5 f3','s3 n7 f4'],
    ['s2 n3 f2','s2 n7 f4','s3 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s3 n7 f4'],



    ['s3 n2 f2','s3 n3 f3','s2 n1 f1'],
    ['s3 n2 f2','s3 n5 f4','s2 n1 f1'],
    ['s3 n2 f2','s3 n5 f3','s2 n1 f1'],
    ['s3 n2 f2','s3 n7 f4','s2 n1 f1'],

    ['s3 n3 f2','s3 n5 f3','s2 n1 f1'],
    ['s3 n3 f2','s3 n7 f4','s2 n1 f1'],
    ['s3 n5 f3','s3 n7 f4','s2 n1 f1'],

    ['s3 n2 f1','s3 n3 f2','s2 n3 f2'],
    ['s3 n2 f1','s3 n5 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n7 f4','s2 n3 f2'],

    ['s3 n3 f2','s3 n5 f3','s2 n3 f2'],
    ['s3 n3 f2','s3 n7 f4','s2 n3 f2'],
    ['s3 n5 f3','s3 n7 f4','s2 n3 f2'],

    ['s3 n2 f1','s3 n3 f2','s2 n5 f3'],
    ['s3 n2 f1','s3 n5 f3','s2 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s2 n5 f3'],

    ['s3 n3 f2','s3 n5 f3','s2 n5 f3'],
    ['s3 n3 f2','s3 n7 f4','s2 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s2 n5 f3'],

    ['s3 n2 f1','s3 n3 f2','s2 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s2 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s2 n7 f4'],

    ['s3 n3 f2','s3 n5 f3','s2 n7 f4'],
    ['s3 n3 f2','s3 n7 f4','s2 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s2 n7 f4'],
  ],
  [
    ['s2 n2 f1','s2 n3 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n5 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s3 n2 f1'],

    ['s2 n3 f2','s2 n5 f3','s3 n2 f1'],
    ['s2 n3 f2','s2 n7 f4','s3 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n3 f2','s3 n3 f2'],
    ['s2 n2 f1','s2 n5 f3','s3 n3 f2'],
    ['s2 n2 f1','s2 n7 f4','s3 n3 f2'],

    ['s2 n3 f2','s2 n5 f3','s3 n3 f2'],
    ['s2 n3 f2','s2 n7 f4','s3 n3 f2'],
    ['s2 n5 f3','s2 n7 f4','s3 n3 f2'],

    ['s2 n2 f1','s2 n3 f2','s3 n5 f3'],
    ['s2 n2 f1','s2 n5 f3','s3 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s3 n5 f3'],

    ['s2 n3 f2','s2 n5 f3','s3 n5 f3'],
    ['s2 n3 f2','s2 n7 f4','s3 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s3 n5 f3'],

    ['s2 n2 f1','s2 n3 f2','s3 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s3 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s3 n7 f4'],

    ['s2 n3 f2','s2 n5 f3','s3 n7 f4'],
    ['s2 n3 f2','s2 n7 f4','s3 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s3 n7 f4'],



    ['s3 n2 f1','s3 n3 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n5 f3','s2 n2 f1'],
    ['s3 n2 f2','s3 n7 f4','s2 n2 f1'],

    ['s3 n3 f2','s3 n5 f3','s2 n2 f1'],
    ['s3 n3 f2','s3 n7 f4','s2 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n3 f2','s2 n3 f2'],
    ['s3 n2 f1','s3 n5 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n7 f4','s2 n3 f2'],

    ['s3 n3 f2','s3 n5 f3','s2 n3 f2'],
    ['s3 n3 f2','s3 n7 f4','s2 n3 f2'],
    ['s3 n5 f3','s3 n7 f4','s2 n3 f2'],

    ['s3 n2 f1','s3 n3 f2','s2 n5 f3'],
    ['s3 n2 f1','s3 n5 f3','s2 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s2 n5 f3'],

    ['s3 n3 f2','s3 n5 f3','s2 n5 f3'],
    ['s3 n3 f2','s3 n7 f4','s2 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s2 n5 f3'],

    ['s3 n2 f1','s3 n3 f2','s2 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s2 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s2 n7 f4'],

    ['s3 n3 f2','s3 n5 f3','s2 n7 f4'],
    ['s3 n3 f2','s3 n7 f4','s2 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s2 n7 f4'],
  ],
  [
    ['s2 n2 f1','s2 n3 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n5 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s3 n2 f1'],

    ['s2 n3 f2','s2 n5 f3','s3 n2 f1'],
    ['s2 n3 f2','s2 n7 f4','s3 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n3 f1','s3 n4 f2'],
    ['s2 n2 f1','s2 n5 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s3 n4 f2'],

    ['s2 n3 f1','s2 n5 f3','s3 n4 f2'],
    ['s2 n3 f1','s2 n7 f4','s3 n4 f2'],
    ['s2 n5 f3','s2 n7 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n3 f2','s3 n5 f3'],
    ['s2 n2 f1','s2 n5 f3','s3 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s3 n5 f3'],

    ['s2 n3 f2','s2 n5 f3','s3 n5 f3'],
    ['s2 n3 f2','s2 n7 f4','s3 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s3 n5 f3'],

    ['s2 n2 f1','s2 n3 f2','s3 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s3 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s3 n7 f4'],

    ['s2 n3 f2','s2 n5 f3','s3 n7 f4'],
    ['s2 n3 f2','s2 n7 f4','s3 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s3 n7 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n5 f3','s2 n2 f1'],
    ['s3 n2 f2','s3 n7 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n5 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s2 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n5 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n7 f4','s2 n3 f2'],

    ['s3 n4 f3','s3 n5 f4','s2 n3 f2'],
    ['s3 n4 f3','s3 n5 f3','s2 n3 f2'],
    ['s3 n4 f3','s3 n7 f4','s2 n3 f2'],
    ['s3 n5 f3','s3 n7 f4','s2 n3 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n5 f3'],
    ['s3 n2 f1','s3 n5 f3','s2 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s2 n5 f3'],

    ['s3 n4 f2','s3 n5 f3','s2 n5 f3'],
    ['s3 n4 f2','s3 n7 f4','s2 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s2 n5 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s2 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s2 n7 f4'],

    ['s3 n4 f2','s3 n5 f3','s2 n7 f4'],
    ['s3 n4 f2','s3 n7 f4','s2 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s2 n7 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n5 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n5 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s3 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n5 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n5 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n7 f4','s3 n4 f2'],
    ['s2 n5 f3','s2 n7 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n5 f3'],
    ['s2 n2 f1','s2 n5 f3','s3 n5 f3'],
    ['s2 n2 f1','s2 n7 f4','s3 n5 f3'],

    ['s2 n4 f2','s2 n5 f3','s3 n5 f3'],
    ['s2 n4 f2','s2 n7 f4','s3 n5 f3'],
    ['s2 n5 f3','s2 n7 f4','s3 n5 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s3 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s3 n7 f4'],

    ['s2 n4 f2','s2 n5 f3','s3 n7 f4'],
    ['s2 n4 f2','s2 n7 f4','s3 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s3 n7 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n5 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n5 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s2 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n5 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n5 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n7 f4','s2 n4 f2'],
    ['s3 n5 f3','s3 n7 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n5 f3'],
    ['s3 n2 f1','s3 n5 f3','s2 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s2 n5 f3'],

    ['s3 n4 f2','s3 n5 f3','s2 n5 f3'],
    ['s3 n4 f2','s3 n7 f4','s2 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s2 n5 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s2 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s2 n7 f4'],

    ['s3 n4 f2','s3 n5 f3','s2 n7 f4'],
    ['s3 n4 f2','s3 n7 f4','s2 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s2 n7 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n5 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n5 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s3 n2 f1'],
    ['s2 n5 f3','s2 n7 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n5 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n5 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n7 f4','s3 n4 f2'],
    ['s2 n5 f3','s2 n7 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n6 f3'],
    ['s2 n2 f1','s2 n5 f2','s3 n6 f3'],
    ['s2 n2 f1','s2 n7 f4','s3 n6 f3'],

    ['s2 n4 f2','s2 n5 f2','s3 n6 f3'],
    ['s2 n4 f2','s2 n7 f4','s3 n6 f3'],
    ['s2 n5 f2','s2 n7 f4','s3 n6 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n7 f4'],
    ['s2 n2 f1','s2 n5 f3','s3 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s3 n7 f4'],

    ['s2 n4 f2','s2 n5 f3','s3 n7 f4'],
    ['s2 n4 f2','s2 n7 f4','s3 n7 f4'],
    ['s2 n5 f3','s2 n7 f4','s3 n7 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n6 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n6 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s2 n2 f1'],
    ['s3 n6 f3','s3 n7 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n6 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n6 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n7 f4','s2 n4 f2'],
    ['s3 n6 f3','s3 n7 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n5 f3'],
    ['s3 n2 f1','s3 n6 f4','s2 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s2 n5 f3'],

    ['s3 n4 f2','s3 n6 f4','s2 n5 f3'],
    ['s3 n4 f2','s3 n7 f4','s2 n5 f3'],
    ['s3 n6 f4','s3 n7 f4','s2 n5 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f4'],
    ['s3 n2 f1','s3 n6 f3','s2 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s2 n7 f4'],

    ['s3 n4 f2','s3 n6 f3','s2 n7 f4'],
    ['s3 n4 f2','s3 n7 f4','s2 n7 f4'],
    ['s3 n6 f3','s3 n7 f4','s2 n7 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n6 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n6 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s3 n2 f1'],
    ['s2 n6 f3','s2 n7 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n6 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n6 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n7 f4','s3 n4 f2'],
    ['s2 n6 f3','s2 n7 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n6 f3'],
    ['s2 n2 f1','s2 n6 f3','s3 n6 f3'],
    ['s2 n2 f1','s2 n7 f4','s3 n6 f3'],

    ['s2 n4 f2','s2 n6 f3','s3 n6 f3'],
    ['s2 n4 f2','s2 n7 f4','s3 n6 f3'],
    ['s2 n6 f3','s2 n7 f4','s3 n6 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n7 f4'],
    ['s2 n2 f1','s2 n6 f3','s3 n7 f4'],
    ['s2 n2 f1','s2 n7 f4','s3 n7 f4'],

    ['s2 n4 f2','s2 n6 f3','s3 n7 f4'],
    ['s2 n4 f2','s2 n7 f4','s3 n7 f4'],
    ['s2 n6 f3','s2 n7 f4','s3 n7 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n6 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n6 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s2 n2 f1'],
    ['s3 n6 f3','s3 n7 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n6 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n6 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n7 f4','s2 n4 f2'],
    ['s3 n6 f3','s3 n7 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n6 f3'],
    ['s3 n2 f1','s3 n6 f3','s2 n6 f3'],
    ['s3 n2 f1','s3 n7 f4','s2 n6 f3'],

    ['s3 n4 f2','s3 n6 f3','s2 n6 f3'],
    ['s3 n4 f2','s3 n7 f4','s2 n6 f3'],
    ['s3 n6 f3','s3 n7 f4','s2 n6 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f4'],
    ['s3 n2 f1','s3 n6 f3','s2 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s2 n7 f4'],

    ['s3 n4 f2','s3 n6 f3','s2 n7 f4'],
    ['s3 n4 f2','s3 n7 f4','s2 n7 f4'],
    ['s3 n6 f3','s3 n7 f4','s2 n7 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n6 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n6 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n7 f4','s3 n2 f1'],
    ['s2 n6 f3','s2 n7 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n6 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n6 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n7 f4','s3 n4 f2'],
    ['s2 n6 f3','s2 n7 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n6 f3'],
    ['s2 n2 f1','s2 n6 f3','s3 n6 f3'],
    ['s2 n2 f1','s2 n7 f4','s3 n6 f3'],

    ['s2 n4 f2','s2 n6 f3','s3 n6 f3'],
    ['s2 n4 f2','s2 n7 f4','s3 n6 f3'],
    ['s2 n6 f3','s2 n7 f4','s3 n6 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n8 f4'],
    ['s2 n2 f1','s2 n6 f3','s3 n8 f4'],
    ['s2 n2 f1','s2 n7 f3','s3 n8 f4'],

    ['s2 n4 f2','s2 n6 f3','s3 n8 f4'],
    ['s2 n4 f2','s2 n7 f3','s3 n8 f4'],
    ['s2 n6 f3','s2 n7 f3','s3 n8 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n6 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n8 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n6 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n8 f4','s2 n2 f1'],
    ['s3 n6 f3','s3 n8 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n6 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n8 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n6 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n8 f4','s2 n4 f2'],
    ['s3 n6 f3','s3 n8 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n6 f3'],
    ['s3 n2 f1','s3 n6 f3','s2 n6 f3'],
    ['s3 n2 f1','s3 n8 f4','s2 n6 f3'],

    ['s3 n4 f2','s3 n6 f3','s2 n6 f3'],
    ['s3 n4 f2','s3 n8 f4','s2 n6 f3'],
    ['s3 n6 f3','s3 n8 f4','s2 n6 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n6 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n8 f4','s2 n7 f3'],

    ['s3 n4 f2','s3 n6 f2','s2 n7 f3'],
    ['s3 n4 f2','s3 n8 f4','s2 n7 f3'],
    ['s3 n6 f2','s3 n8 f4','s2 n7 f3'],
  ]
],

GD:[
  [
    ['s3 n1 f1','s3 n3 f3','s4 n2 f2'],
    ['s3 n1 f1','s3 n5 f4','s4 n2 f2'],
    ['s3 n1 f1','s3 n5 f3','s4 n2 f2'],
    ['s3 n1 f1','s3 n7 f4','s4 n2 f2'],

    ['s3 n3 f2','s3 n5 f3','s4 n2 f1'],
    ['s3 n3 f2','s3 n7 f4','s4 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s4 n2 f1'],

    ['s3 n1 f1','s3 n3 f2','s4 n3 f2'],
    ['s3 n1 f1','s3 n5 f3','s4 n3 f2'],
    ['s3 n1 f1','s3 n7 f4','s4 n3 f2'],

    ['s3 n3 f2','s3 n5 f3','s4 n3 f2'],
    ['s3 n3 f2','s3 n7 f4','s4 n3 f2'],
    ['s3 n5 f3','s3 n7 f4','s4 n3 f2'],

    ['s3 n1 f1','s3 n3 f2','s4 n5 f3'],
    ['s3 n1 f1','s3 n5 f3','s4 n5 f3'],
    ['s3 n1 f1','s3 n7 f4','s4 n5 f3'],

    ['s3 n3 f2','s3 n5 f3','s4 n5 f3'],
    ['s3 n3 f2','s3 n7 f4','s4 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s4 n5 f3'],

    ['s3 n1 f1','s3 n3 f2','s4 n7 f4'],
    ['s3 n1 f1','s3 n5 f3','s4 n7 f4'],
    ['s3 n1 f1','s3 n7 f4','s4 n7 f4'],

    ['s3 n3 f2','s3 n5 f3','s4 n7 f4'],
    ['s3 n3 f2','s3 n7 f4','s4 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s4 n7 f4'],



    ['s4 n2 f2','s4 n3 f3','s3 n1 f1'],
    ['s4 n2 f2','s4 n5 f4','s3 n1 f1'],
    ['s4 n2 f2','s4 n5 f3','s3 n1 f1'],
    ['s4 n2 f2','s4 n7 f4','s3 n1 f1'],

    ['s4 n3 f2','s4 n5 f3','s3 n1 f1'],
    ['s4 n3 f2','s4 n7 f4','s3 n1 f1'],
    ['s4 n5 f3','s4 n7 f4','s3 n1 f1'],

    ['s4 n2 f1','s4 n3 f2','s3 n3 f2'],
    ['s4 n2 f1','s4 n5 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n7 f4','s3 n3 f2'],

    ['s4 n3 f2','s4 n5 f3','s3 n3 f2'],
    ['s4 n3 f2','s4 n7 f4','s3 n3 f2'],
    ['s4 n5 f3','s4 n7 f4','s3 n3 f2'],

    ['s4 n2 f1','s4 n3 f2','s3 n5 f3'],
    ['s4 n2 f1','s4 n5 f3','s3 n5 f3'],
    ['s4 n2 f1','s4 n7 f4','s3 n5 f3'],

    ['s4 n3 f2','s4 n5 f3','s3 n5 f3'],
    ['s4 n3 f2','s4 n7 f4','s3 n5 f3'],
    ['s4 n5 f3','s4 n7 f4','s3 n5 f3'],

    ['s4 n2 f1','s4 n3 f2','s3 n7 f4'],
    ['s4 n2 f1','s4 n5 f3','s3 n7 f4'],
    ['s4 n2 f1','s4 n7 f4','s3 n7 f4'],

    ['s4 n3 f2','s4 n5 f3','s3 n7 f4'],
    ['s4 n3 f2','s4 n7 f4','s3 n7 f4'],
    ['s4 n5 f3','s4 n7 f4','s3 n7 f4'],
  ],
    [
    ['s3 n2 f1','s3 n3 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n5 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s4 n2 f1'],

    ['s3 n3 f2','s3 n5 f3','s4 n2 f1'],
    ['s3 n3 f2','s3 n7 f4','s4 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n3 f2','s4 n3 f2'],
    ['s3 n2 f1','s3 n5 f3','s4 n3 f2'],
    ['s3 n2 f1','s3 n7 f4','s4 n3 f2'],

    ['s3 n3 f2','s3 n5 f3','s4 n3 f2'],
    ['s3 n3 f2','s3 n7 f4','s4 n3 f2'],
    ['s3 n5 f3','s3 n7 f4','s4 n3 f2'],

    ['s3 n2 f1','s3 n3 f2','s4 n5 f3'],
    ['s3 n2 f1','s3 n5 f3','s4 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s4 n5 f3'],

    ['s3 n3 f2','s3 n5 f3','s4 n5 f3'],
    ['s3 n3 f2','s3 n7 f4','s4 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s4 n5 f3'],

    ['s3 n2 f1','s3 n3 f2','s4 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s4 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s4 n7 f4'],

    ['s3 n3 f2','s3 n5 f3','s4 n7 f4'],
    ['s3 n3 f2','s3 n7 f4','s4 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s4 n7 f4'],



    ['s4 n2 f1','s4 n3 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n5 f3','s3 n2 f1'],
    ['s4 n2 f2','s4 n7 f4','s3 n2 f1'],

    ['s4 n3 f2','s4 n5 f3','s3 n2 f1'],
    ['s4 n3 f2','s4 n7 f4','s3 n2 f1'],
    ['s4 n5 f3','s4 n7 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n3 f2','s3 n3 f2'],
    ['s4 n2 f1','s4 n5 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n7 f4','s3 n3 f2'],

    ['s4 n3 f2','s4 n5 f3','s3 n3 f2'],
    ['s4 n3 f2','s4 n7 f4','s3 n3 f2'],
    ['s4 n5 f3','s4 n7 f4','s3 n3 f2'],

    ['s4 n2 f1','s4 n3 f2','s3 n5 f3'],
    ['s4 n2 f1','s4 n5 f3','s3 n5 f3'],
    ['s4 n2 f1','s4 n7 f4','s3 n5 f3'],

    ['s4 n3 f2','s4 n5 f3','s3 n5 f3'],
    ['s4 n3 f2','s4 n7 f4','s3 n5 f3'],
    ['s4 n5 f3','s4 n7 f4','s3 n5 f3'],

    ['s4 n2 f1','s4 n3 f2','s3 n7 f4'],
    ['s4 n2 f1','s4 n5 f3','s3 n7 f4'],
    ['s4 n2 f1','s4 n7 f4','s3 n7 f4'],

    ['s4 n3 f2','s4 n5 f3','s3 n7 f4'],
    ['s4 n3 f2','s4 n7 f4','s3 n7 f4'],
    ['s4 n5 f3','s4 n7 f4','s3 n7 f4'],
  ],
  [
    ['s3 n2 f1','s3 n3 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n5 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s4 n2 f1'],

    ['s3 n3 f2','s3 n5 f3','s4 n2 f1'],
    ['s3 n3 f2','s3 n7 f4','s4 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n3 f1','s4 n4 f2'],
    ['s3 n2 f1','s3 n5 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s4 n4 f2'],

    ['s3 n3 f1','s3 n5 f3','s4 n4 f2'],
    ['s3 n3 f1','s3 n7 f4','s4 n4 f2'],
    ['s3 n5 f3','s3 n7 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n3 f2','s4 n5 f3'],
    ['s3 n2 f1','s3 n5 f3','s4 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s4 n5 f3'],

    ['s3 n3 f2','s3 n5 f3','s4 n5 f3'],
    ['s3 n3 f2','s3 n7 f4','s4 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s4 n5 f3'],

    ['s3 n2 f1','s3 n3 f2','s4 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s4 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s4 n7 f4'],

    ['s3 n3 f2','s3 n5 f3','s4 n7 f4'],
    ['s3 n3 f2','s3 n7 f4','s4 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s4 n7 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n5 f3','s3 n2 f1'],
    ['s4 n2 f2','s4 n7 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n5 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n7 f4','s3 n2 f1'],
    ['s4 n5 f3','s4 n7 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n5 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n7 f4','s3 n3 f2'],

    ['s4 n4 f3','s4 n5 f4','s3 n3 f2'],
    ['s4 n4 f3','s4 n5 f3','s3 n3 f2'],
    ['s4 n4 f3','s4 n7 f4','s3 n3 f2'],
    ['s4 n5 f3','s4 n7 f4','s3 n3 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n5 f3'],
    ['s4 n2 f1','s4 n5 f3','s3 n5 f3'],
    ['s4 n2 f1','s4 n7 f4','s3 n5 f3'],

    ['s4 n4 f2','s4 n5 f3','s3 n5 f3'],
    ['s4 n4 f2','s4 n7 f4','s3 n5 f3'],
    ['s4 n5 f3','s4 n7 f4','s3 n5 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f4'],
    ['s4 n2 f1','s4 n5 f3','s3 n7 f4'],
    ['s4 n2 f1','s4 n7 f4','s3 n7 f4'],

    ['s4 n4 f2','s4 n5 f3','s3 n7 f4'],
    ['s4 n4 f2','s4 n7 f4','s3 n7 f4'],
    ['s4 n5 f3','s4 n7 f4','s3 n7 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n5 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n5 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s4 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n5 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n5 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n7 f4','s4 n4 f2'],
    ['s3 n5 f3','s3 n7 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n5 f3'],
    ['s3 n2 f1','s3 n5 f3','s4 n5 f3'],
    ['s3 n2 f1','s3 n7 f4','s4 n5 f3'],

    ['s3 n4 f2','s3 n5 f3','s4 n5 f3'],
    ['s3 n4 f2','s3 n7 f4','s4 n5 f3'],
    ['s3 n5 f3','s3 n7 f4','s4 n5 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s4 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s4 n7 f4'],

    ['s3 n4 f2','s3 n5 f3','s4 n7 f4'],
    ['s3 n4 f2','s3 n7 f4','s4 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s4 n7 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n5 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n5 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n7 f4','s3 n2 f1'],
    ['s4 n5 f3','s4 n7 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n5 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n7 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n5 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n7 f4','s3 n4 f2'],
    ['s4 n5 f3','s4 n7 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n5 f3'],
    ['s4 n2 f1','s4 n5 f3','s3 n5 f3'],
    ['s4 n2 f1','s4 n7 f4','s3 n5 f3'],

    ['s4 n4 f2','s4 n5 f3','s3 n5 f3'],
    ['s4 n4 f2','s4 n7 f4','s3 n5 f3'],
    ['s4 n5 f3','s4 n7 f4','s3 n5 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f4'],
    ['s4 n2 f1','s4 n5 f3','s3 n7 f4'],
    ['s4 n2 f1','s4 n7 f4','s3 n7 f4'],

    ['s4 n4 f2','s4 n5 f3','s3 n7 f4'],
    ['s4 n4 f2','s4 n7 f4','s3 n7 f4'],
    ['s4 n5 f3','s4 n7 f4','s3 n7 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n5 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n5 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s4 n2 f1'],
    ['s3 n5 f3','s3 n7 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n5 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n5 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n7 f4','s4 n4 f2'],
    ['s3 n5 f3','s3 n7 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n6 f3'],
    ['s3 n2 f1','s3 n5 f2','s4 n6 f3'],
    ['s3 n2 f1','s3 n7 f4','s4 n6 f3'],

    ['s3 n4 f2','s3 n5 f2','s4 n6 f3'],
    ['s3 n4 f2','s3 n7 f4','s4 n6 f3'],
    ['s3 n5 f2','s3 n7 f4','s4 n6 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n7 f4'],
    ['s3 n2 f1','s3 n5 f3','s4 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s4 n7 f4'],

    ['s3 n4 f2','s3 n5 f3','s4 n7 f4'],
    ['s3 n4 f2','s3 n7 f4','s4 n7 f4'],
    ['s3 n5 f3','s3 n7 f4','s4 n7 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n6 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n6 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n7 f4','s3 n2 f1'],
    ['s4 n6 f3','s4 n7 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n6 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n7 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n6 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n7 f4','s3 n4 f2'],
    ['s4 n6 f3','s4 n7 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n5 f3'],
    ['s4 n2 f1','s4 n6 f4','s3 n5 f3'],
    ['s4 n2 f1','s4 n7 f4','s3 n5 f3'],

    ['s4 n4 f2','s4 n6 f4','s3 n5 f3'],
    ['s4 n4 f2','s4 n7 f4','s3 n5 f3'],
    ['s4 n6 f4','s4 n7 f4','s3 n5 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f4'],
    ['s4 n2 f1','s4 n6 f3','s3 n7 f4'],
    ['s4 n2 f1','s4 n7 f4','s3 n7 f4'],

    ['s4 n4 f2','s4 n6 f3','s3 n7 f4'],
    ['s4 n4 f2','s4 n7 f4','s3 n7 f4'],
    ['s4 n6 f3','s4 n7 f4','s3 n7 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n6 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n6 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s4 n2 f1'],
    ['s3 n6 f3','s3 n7 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n6 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n6 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n7 f4','s4 n4 f2'],
    ['s3 n6 f3','s3 n7 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n6 f3'],
    ['s3 n2 f1','s3 n6 f3','s4 n6 f3'],
    ['s3 n2 f1','s3 n7 f4','s4 n6 f3'],

    ['s3 n4 f2','s3 n6 f3','s4 n6 f3'],
    ['s3 n4 f2','s3 n7 f4','s4 n6 f3'],
    ['s3 n6 f3','s3 n7 f4','s4 n6 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n7 f4'],
    ['s3 n2 f1','s3 n6 f3','s4 n7 f4'],
    ['s3 n2 f1','s3 n7 f4','s4 n7 f4'],

    ['s3 n4 f2','s3 n6 f3','s4 n7 f4'],
    ['s3 n4 f2','s3 n7 f4','s4 n7 f4'],
    ['s3 n6 f3','s3 n7 f4','s4 n7 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n6 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n6 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n7 f4','s3 n2 f1'],
    ['s4 n6 f3','s4 n7 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n6 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n7 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n6 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n7 f4','s3 n4 f2'],
    ['s4 n6 f3','s4 n7 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n6 f3'],
    ['s4 n2 f1','s4 n6 f3','s3 n6 f3'],
    ['s4 n2 f1','s4 n7 f4','s3 n6 f3'],

    ['s4 n4 f2','s4 n6 f3','s3 n6 f3'],
    ['s4 n4 f2','s4 n7 f4','s3 n6 f3'],
    ['s4 n6 f3','s4 n7 f4','s3 n6 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f4'],
    ['s4 n2 f1','s4 n6 f3','s3 n7 f4'],
    ['s4 n2 f1','s4 n7 f4','s3 n7 f4'],

    ['s4 n4 f2','s4 n6 f3','s3 n7 f4'],
    ['s4 n4 f2','s4 n7 f4','s3 n7 f4'],
    ['s4 n6 f3','s4 n7 f4','s3 n7 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n6 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n6 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n7 f4','s4 n2 f1'],
    ['s3 n6 f3','s3 n7 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n6 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n6 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n7 f4','s4 n4 f2'],
    ['s3 n6 f3','s3 n7 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n6 f3'],
    ['s3 n2 f1','s3 n6 f3','s4 n6 f3'],
    ['s3 n2 f1','s3 n7 f4','s4 n6 f3'],

    ['s3 n4 f2','s3 n6 f3','s4 n6 f3'],
    ['s3 n4 f2','s3 n7 f4','s4 n6 f3'],
    ['s3 n6 f3','s3 n7 f4','s4 n6 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n8 f4'],
    ['s3 n2 f1','s3 n6 f3','s4 n8 f4'],
    ['s3 n2 f1','s3 n7 f3','s4 n8 f4'],

    ['s3 n4 f2','s3 n6 f3','s4 n8 f4'],
    ['s3 n4 f2','s3 n7 f3','s4 n8 f4'],
    ['s3 n6 f3','s3 n7 f3','s4 n8 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n6 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n8 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n6 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n8 f4','s3 n2 f1'],
    ['s4 n6 f3','s4 n8 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n6 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n8 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n6 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n8 f4','s3 n4 f2'],
    ['s4 n6 f3','s4 n8 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n6 f3'],
    ['s4 n2 f1','s4 n6 f3','s3 n6 f3'],
    ['s4 n2 f1','s4 n8 f4','s3 n6 f3'],

    ['s4 n4 f2','s4 n6 f3','s3 n6 f3'],
    ['s4 n4 f2','s4 n8 f4','s3 n6 f3'],
    ['s4 n6 f3','s4 n8 f4','s3 n6 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n6 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n8 f4','s3 n7 f3'],

    ['s4 n4 f2','s4 n6 f2','s3 n7 f3'],
    ['s4 n4 f2','s4 n8 f4','s3 n7 f3'],
    ['s4 n6 f2','s4 n8 f4','s3 n7 f3'],
  ],
],
  eGD:[
  [

    ['s3 n3 f2','s3 n7 f3','s4 n2 f1'],
    ['s3 n3 f2','s3 n8 f4','s4 n2 f1'],
    ['s3 n7 f3','s3 n8 f4','s4 n2 f1'],

    ['s3 n1 f1','s3 n3 f2','s4 n3 f2'],
    ['s3 n1 f1','s3 n7 f3','s4 n3 f2'],
    ['s3 n1 f1','s3 n8 f4','s4 n3 f2'],

    ['s3 n3 f2','s3 n7 f3','s4 n3 f2'],
    ['s3 n3 f2','s3 n8 f4','s4 n3 f2'],
    ['s3 n7 f3','s3 n8 f4','s4 n3 f2'],

    ['s3 n1 f1','s3 n3 f2','s4 n7 f3'],
    ['s3 n1 f1','s3 n7 f3','s4 n7 f3'],
    ['s3 n1 f1','s3 n8 f4','s4 n7 f3'],

    ['s3 n3 f2','s3 n7 f3','s4 n7 f3'],
    ['s3 n3 f2','s3 n8 f4','s4 n7 f3'],
    ['s3 n7 f3','s3 n8 f4','s4 n7 f3'],

    ['s3 n1 f1','s3 n3 f2','s4 n8 f4'],
    ['s3 n1 f1','s3 n7 f3','s4 n8 f4'],
    ['s3 n1 f1','s3 n8 f4','s4 n8 f4'],

    ['s3 n3 f2','s3 n7 f3','s4 n8 f4'],
    ['s3 n3 f2','s3 n8 f4','s4 n8 f4'],
    ['s3 n7 f3','s3 n8 f4','s4 n8 f4'],




    ['s4 n2 f1','s4 n3 f2','s3 n3 f2'],
    ['s4 n2 f1','s4 n7 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n8 f4','s3 n3 f2'],

    ['s4 n3 f2','s4 n7 f3','s3 n3 f2'],
    ['s4 n3 f2','s4 n8 f4','s3 n3 f2'],
    ['s4 n7 f3','s4 n8 f4','s3 n3 f2'],

    ['s4 n2 f1','s4 n3 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n7 f3','s3 n7 f3'],
    ['s4 n2 f1','s4 n8 f4','s3 n7 f3'],

    ['s4 n3 f2','s4 n7 f3','s3 n7 f3'],
    ['s4 n3 f2','s4 n8 f4','s3 n7 f3'],
    ['s4 n7 f3','s4 n8 f4','s3 n7 f3'],

    ['s4 n2 f1','s4 n3 f2','s3 n8 f4'],
    ['s4 n2 f1','s4 n7 f3','s3 n8 f4'],
    ['s4 n2 f1','s4 n8 f4','s3 n8 f4'],

    ['s4 n3 f2','s4 n7 f3','s3 n8 f4'],
    ['s4 n3 f2','s4 n8 f4','s3 n8 f4'],
    ['s4 n7 f3','s4 n8 f4','s3 n8 f4'],
  ],
   [
    ['s3 n2 f1','s3 n3 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n8 f4','s4 n2 f1'],

    ['s3 n3 f2','s3 n7 f3','s4 n2 f1'],
    ['s3 n3 f2','s3 n8 f4','s4 n2 f1'],
    ['s3 n7 f3','s3 n8 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n3 f2','s4 n3 f2'],
    ['s3 n2 f1','s3 n7 f3','s4 n3 f2'],
    ['s3 n2 f1','s3 n8 f4','s4 n3 f2'],

    ['s3 n3 f2','s3 n7 f3','s4 n3 f2'],
    ['s3 n3 f2','s3 n8 f4','s4 n3 f2'],
    ['s3 n7 f3','s3 n8 f4','s4 n3 f2'],

    ['s3 n2 f1','s3 n3 f2','s4 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s4 n7 f3'],
    ['s3 n2 f1','s3 n8 f4','s4 n7 f3'],

    ['s3 n3 f2','s3 n7 f3','s4 n7 f3'],
    ['s3 n3 f2','s3 n8 f4','s4 n7 f3'],
    ['s3 n7 f3','s3 n8 f4','s4 n7 f3'],

    ['s3 n2 f1','s3 n3 f2','s4 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s4 n9 f4'],

    ['s3 n3 f2','s3 n7 f3','s4 n9 f4'],



    ['s4 n2 f1','s4 n3 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n9 f4','s3 n2 f1'],

    ['s4 n3 f2','s4 n7 f3','s3 n2 f1'],
    ['s4 n3 f2','s4 n9 f4','s3 n2 f1'],
    ['s4 n7 f3','s4 n9 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n3 f2','s3 n3 f2'],
    ['s4 n2 f1','s4 n7 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n9 f4','s3 n3 f2'],

    ['s4 n3 f2','s4 n7 f3','s3 n3 f2'],
    ['s4 n3 f2','s4 n9 f4','s3 n3 f2'],
    ['s4 n7 f3','s4 n9 f4','s3 n3 f2'],

    ['s4 n2 f1','s4 n3 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n7 f3','s3 n7 f3'],
    ['s4 n2 f1','s4 n9 f4','s3 n7 f3'],

    ['s4 n3 f2','s4 n7 f3','s3 n7 f3'],
    ['s4 n3 f2','s4 n9 f4','s3 n7 f3'],
    ['s4 n7 f3','s4 n9 f4','s3 n7 f3'],

    ['s4 n2 f1','s4 n3 f2','s3 n8 f4'],
    ['s4 n2 f1','s4 n7 f3','s3 n8 f4'],

    ['s4 n3 f2','s4 n7 f3','s3 n8 f4'],
  ],
  [
    ['s3 n2 f1','s3 n3 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s4 n2 f1'],

    ['s3 n3 f2','s3 n7 f3','s4 n2 f1'],
    ['s3 n3 f2','s3 n9 f4','s4 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n3 f1','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s4 n4 f2'],

    ['s3 n3 f1','s3 n7 f3','s4 n4 f2'],
    ['s3 n3 f1','s3 n9 f4','s4 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n3 f2','s4 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s4 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s4 n7 f3'],

    ['s3 n3 f2','s3 n7 f3','s4 n7 f3'],
    ['s3 n3 f2','s3 n9 f4','s4 n7 f3'],
    ['s3 n7 f3','s3 n9 f4','s4 n7 f3'],

    ['s3 n2 f1','s3 n3 f2','s4 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s4 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s4 n9 f4'],

    ['s3 n3 f2','s3 n7 f3','s4 n9 f4'],
    ['s3 n3 f2','s3 n9 f4','s4 n9 f4'],
    ['s3 n7 f3','s3 n9 f4','s4 n9 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f3','s3 n2 f1'],
    ['s4 n2 f2','s4 n9 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n7 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n9 f4','s3 n2 f1'],
    ['s4 n7 f3','s4 n9 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n7 f3','s3 n3 f2'],
    ['s4 n2 f1','s4 n9 f4','s3 n3 f2'],

    ['s4 n4 f3','s4 n7 f3','s3 n3 f2'],
    ['s4 n4 f3','s4 n9 f4','s3 n3 f2'],
    ['s4 n7 f3','s4 n9 f4','s3 n3 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n7 f3','s3 n7 f3'],
    ['s4 n2 f1','s4 n9 f4','s3 n7 f3'],

    ['s4 n4 f2','s4 n7 f3','s3 n7 f3'],
    ['s4 n4 f2','s4 n9 f4','s3 n7 f3'],
    ['s4 n7 f3','s4 n9 f4','s3 n7 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n9 f4'],
    ['s4 n2 f1','s4 n7 f3','s3 n9 f4'],
    ['s4 n2 f1','s4 n9 f4','s3 n9 f4'],

    ['s4 n4 f2','s4 n7 f3','s3 n9 f4'],
    ['s4 n4 f2','s4 n9 f4','s3 n9 f4'],
    ['s4 n7 f3','s4 n9 f4','s3 n9 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s4 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n7 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s4 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s4 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s4 n7 f3'],

    ['s3 n4 f2','s3 n7 f3','s4 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s4 n7 f3'],
    ['s3 n7 f3','s3 n9 f4','s4 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s4 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s4 n9 f4'],

    ['s3 n4 f2','s3 n7 f3','s4 n9 f4'],
    ['s3 n4 f2','s3 n9 f4','s4 n9 f4'],
    ['s3 n7 f3','s3 n9 f4','s4 n9 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n9 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n7 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n9 f4','s3 n2 f1'],
    ['s4 n7 f3','s4 n9 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n7 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n9 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n7 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n9 f4','s3 n4 f2'],
    ['s4 n7 f3','s4 n9 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n7 f3','s3 n7 f3'],
    ['s4 n2 f1','s4 n9 f4','s3 n7 f3'],

    ['s4 n4 f2','s4 n7 f3','s3 n7 f3'],
    ['s4 n4 f2','s4 n9 f4','s3 n7 f3'],
    ['s4 n7 f3','s4 n9 f4','s3 n7 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n9 f4'],
    ['s4 n2 f1','s4 n7 f3','s3 n9 f4'],
    ['s4 n2 f1','s4 n9 f4','s3 n9 f4'],

    ['s4 n4 f2','s4 n7 f3','s3 n9 f4'],
    ['s4 n4 f2','s4 n9 f4','s3 n9 f4'],
    ['s4 n7 f3','s4 n9 f4','s3 n9 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s4 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n7 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s4 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n7 f3'],
    ['s3 n2 f1','s3 n7 f2','s4 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s4 n7 f3'],

    ['s3 n4 f2','s3 n7 f2','s4 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s4 n7 f3'],
    ['s3 n7 f2','s3 n9 f4','s4 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s4 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s4 n9 f4'],

    ['s3 n4 f2','s3 n7 f3','s4 n9 f4'],
    ['s3 n4 f2','s3 n9 f4','s4 n9 f4'],
    ['s3 n7 f3','s3 n9 f4','s4 n9 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n9 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n7 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n9 f4','s3 n2 f1'],
    ['s4 n7 f3','s4 n9 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n7 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n9 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n7 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n9 f4','s3 n4 f2'],
    ['s4 n7 f3','s4 n9 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n7 f4','s3 n7 f3'],
    ['s4 n2 f1','s4 n9 f4','s3 n7 f3'],

    ['s4 n4 f2','s4 n7 f4','s3 n7 f3'],
    ['s4 n4 f2','s4 n9 f4','s3 n7 f3'],
    ['s4 n7 f4','s4 n9 f4','s3 n7 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f4'],
    ['s4 n2 f1','s4 n7 f3','s3 n7 f4'],
    ['s4 n2 f1','s4 n9 f4','s3 n7 f4'],

    ['s4 n4 f2','s4 n7 f3','s3 n7 f4'],
    ['s4 n4 f2','s4 n9 f4','s3 n7 f4'],
    ['s4 n7 f3','s4 n9 f4','s3 n7 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s4 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n7 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s4 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s4 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s4 n7 f3'],

    ['s3 n4 f2','s3 n7 f3','s4 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s4 n7 f3'],
    ['s3 n7 f3','s3 n9 f4','s4 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s4 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s4 n9 f4'],

    ['s3 n4 f2','s3 n7 f3','s4 n9 f4'],
    ['s3 n4 f2','s3 n9 f4','s4 n9 f4'],
    ['s3 n7 f3','s3 n9 f4','s4 n9 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n7 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n9 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n7 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n9 f4','s3 n2 f1'],
    ['s4 n7 f3','s4 n9 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n7 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n9 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n7 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n9 f4','s3 n4 f2'],
    ['s4 n7 f3','s4 n9 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n7 f3','s3 n7 f3'],
    ['s4 n2 f1','s4 n9 f4','s3 n7 f3'],

    ['s4 n4 f2','s4 n7 f3','s3 n7 f3'],
    ['s4 n4 f2','s4 n9 f4','s3 n7 f3'],
    ['s4 n7 f3','s4 n9 f4','s3 n7 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n9 f4'],
    ['s4 n2 f1','s4 n7 f3','s3 n9 f4'],
    ['s4 n2 f1','s4 n9 f4','s3 n9 f4'],

    ['s4 n4 f2','s4 n7 f3','s3 n9 f4'],
    ['s4 n4 f2','s4 n9 f4','s3 n9 f4'],
    ['s4 n7 f3','s4 n9 f4','s3 n9 f4'],
  ],
  [
    ['s3 n2 f1','s3 n4 f2','s4 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s4 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s4 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s4 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s4 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s4 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s4 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s4 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s4 n4 f2'],

    ['s3 n4 f2','s3 n7 f3','s4 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s4 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s4 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s4 n8 f3'],
    ['s3 n2 f1','s3 n9 f4','s4 n8 f3'],

    ['s3 n7 f2','s3 n9 f4','s4 n8 f3'],

    ['s3 n2 f1','s3 n4 f2','s4 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s4 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s4 n9 f4'],

    ['s3 n4 f2','s3 n7 f3','s4 n9 f4'],
    ['s3 n4 f2','s3 n9 f3','s4 n9 f4'],
    ['s3 n7 f3','s3 n9 f3','s4 n9 f4'],



    ['s4 n2 f1','s4 n4 f2','s3 n2 f1'],
    ['s4 n2 f1','s4 n8 f3','s3 n2 f1'],
    ['s4 n2 f1','s4 n9 f4','s3 n2 f1'],

    ['s4 n4 f2','s4 n8 f3','s3 n2 f1'],
    ['s4 n4 f2','s4 n9 f4','s3 n2 f1'],
    ['s4 n8 f3','s4 n9 f4','s3 n2 f1'],

    ['s4 n2 f1','s4 n4 f2','s3 n4 f2'],
    ['s4 n2 f1','s4 n8 f3','s3 n4 f2'],
    ['s4 n2 f1','s4 n9 f4','s3 n4 f2'],

    ['s4 n4 f2','s4 n8 f3','s3 n4 f2'],
    ['s4 n4 f2','s4 n9 f4','s3 n4 f2'],
    ['s4 n8 f3','s4 n9 f4','s3 n4 f2'],

    ['s4 n2 f1','s4 n4 f2','s3 n7 f3'],
    ['s4 n2 f1','s4 n8 f4','s3 n7 f3'],
    ['s4 n2 f1','s4 n9 f4','s3 n7 f3'],

    ['s4 n4 f2','s4 n8 f4','s3 n7 f3'],
    ['s4 n4 f2','s4 n9 f4','s3 n7 f3'],
    ['s4 n8 f4','s4 n9 f4','s3 n7 f3'],

    ['s4 n2 f1','s4 n4 f2','s3 n9 f4'],
    ['s4 n2 f1','s4 n8 f3','s3 n9 f4'],
    ['s4 n2 f1','s4 n9 f4','s3 n9 f4'],

    ['s4 n4 f2','s4 n8 f3','s3 n9 f4'],
    ['s4 n4 f2','s4 n9 f4','s3 n9 f4'],
    ['s4 n8 f3','s4 n9 f4','s3 n9 f4'],
  ]

],
eDA:[
  [

    ['s2 n3 f2','s2 n7 f3','s3 n2 f1'],
    ['s2 n3 f2','s2 n8 f4','s3 n2 f1'],
    ['s2 n7 f3','s2 n8 f4','s3 n2 f1'],

    ['s2 n1 f1','s2 n3 f2','s3 n3 f2'],
    ['s2 n1 f1','s2 n7 f3','s3 n3 f2'],
    ['s2 n1 f1','s2 n8 f4','s3 n3 f2'],

    ['s2 n3 f2','s2 n7 f3','s3 n3 f2'],
    ['s2 n3 f2','s2 n8 f4','s3 n3 f2'],
    ['s2 n7 f3','s2 n8 f4','s3 n3 f2'],

    ['s2 n1 f1','s2 n3 f2','s3 n7 f3'],
    ['s2 n1 f1','s2 n7 f3','s3 n7 f3'],
    ['s2 n1 f1','s2 n8 f4','s3 n7 f3'],

    ['s2 n3 f2','s2 n7 f3','s3 n7 f3'],
    ['s2 n3 f2','s2 n8 f4','s3 n7 f3'],
    ['s2 n7 f3','s2 n8 f4','s3 n7 f3'],

    ['s2 n1 f1','s2 n3 f2','s3 n8 f4'],
    ['s2 n1 f1','s2 n7 f3','s3 n8 f4'],
    ['s2 n1 f1','s2 n8 f4','s3 n8 f4'],

    ['s2 n3 f2','s2 n7 f3','s3 n8 f4'],
    ['s2 n3 f2','s2 n8 f4','s3 n8 f4'],
    ['s2 n7 f3','s2 n8 f4','s3 n8 f4'],




    ['s3 n2 f1','s3 n3 f2','s2 n3 f2'],
    ['s3 n2 f1','s3 n7 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n8 f4','s2 n3 f2'],

    ['s3 n3 f2','s3 n7 f3','s2 n3 f2'],
    ['s3 n3 f2','s3 n8 f4','s2 n3 f2'],
    ['s3 n7 f3','s3 n8 f4','s2 n3 f2'],

    ['s3 n2 f1','s3 n3 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s2 n7 f3'],
    ['s3 n2 f1','s3 n8 f4','s2 n7 f3'],

    ['s3 n3 f2','s3 n7 f3','s2 n7 f3'],
    ['s3 n3 f2','s3 n8 f4','s2 n7 f3'],
    ['s3 n7 f3','s3 n8 f4','s2 n7 f3'],

    ['s3 n2 f1','s3 n3 f2','s2 n8 f4'],
    ['s3 n2 f1','s3 n7 f3','s2 n8 f4'],
    ['s3 n2 f1','s3 n8 f4','s2 n8 f4'],

    ['s3 n3 f2','s3 n7 f3','s2 n8 f4'],
    ['s3 n3 f2','s3 n8 f4','s2 n8 f4'],
    ['s3 n7 f3','s3 n8 f4','s2 n8 f4'],
  ],
   [
    ['s2 n2 f1','s2 n3 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n8 f4','s3 n2 f1'],

    ['s2 n3 f2','s2 n7 f3','s3 n2 f1'],
    ['s2 n3 f2','s2 n8 f4','s3 n2 f1'],
    ['s2 n7 f3','s2 n8 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n3 f2','s3 n3 f2'],
    ['s2 n2 f1','s2 n7 f3','s3 n3 f2'],
    ['s2 n2 f1','s2 n8 f4','s3 n3 f2'],

    ['s2 n3 f2','s2 n7 f3','s3 n3 f2'],
    ['s2 n3 f2','s2 n8 f4','s3 n3 f2'],
    ['s2 n7 f3','s2 n8 f4','s3 n3 f2'],

    ['s2 n2 f1','s2 n3 f2','s3 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s3 n7 f3'],
    ['s2 n2 f1','s2 n8 f4','s3 n7 f3'],

    ['s2 n3 f2','s2 n7 f3','s3 n7 f3'],
    ['s2 n3 f2','s2 n8 f4','s3 n7 f3'],
    ['s2 n7 f3','s2 n8 f4','s3 n7 f3'],

    ['s2 n2 f1','s2 n3 f2','s3 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s3 n9 f4'],

    ['s2 n3 f2','s2 n7 f3','s3 n9 f4'],



    ['s3 n2 f1','s3 n3 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s2 n2 f1'],

    ['s3 n3 f2','s3 n7 f3','s2 n2 f1'],
    ['s3 n3 f2','s3 n9 f4','s2 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n3 f2','s2 n3 f2'],
    ['s3 n2 f1','s3 n7 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n9 f4','s2 n3 f2'],

    ['s3 n3 f2','s3 n7 f3','s2 n3 f2'],
    ['s3 n3 f2','s3 n9 f4','s2 n3 f2'],
    ['s3 n7 f3','s3 n9 f4','s2 n3 f2'],

    ['s3 n2 f1','s3 n3 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s2 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s2 n7 f3'],

    ['s3 n3 f2','s3 n7 f3','s2 n7 f3'],
    ['s3 n3 f2','s3 n9 f4','s2 n7 f3'],
    ['s3 n7 f3','s3 n9 f4','s2 n7 f3'],

    ['s3 n2 f1','s3 n3 f2','s2 n8 f4'],
    ['s3 n2 f1','s3 n7 f3','s2 n8 f4'],

    ['s3 n3 f2','s3 n7 f3','s2 n8 f4'],
  ],
  [
    ['s2 n2 f1','s2 n3 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s3 n2 f1'],

    ['s2 n3 f2','s2 n7 f3','s3 n2 f1'],
    ['s2 n3 f2','s2 n9 f4','s3 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n3 f1','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s3 n4 f2'],

    ['s2 n3 f1','s2 n7 f3','s3 n4 f2'],
    ['s2 n3 f1','s2 n9 f4','s3 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n3 f2','s3 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s3 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s3 n7 f3'],

    ['s2 n3 f2','s2 n7 f3','s3 n7 f3'],
    ['s2 n3 f2','s2 n9 f4','s3 n7 f3'],
    ['s2 n7 f3','s2 n9 f4','s3 n7 f3'],

    ['s2 n2 f1','s2 n3 f2','s3 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s3 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s3 n9 f4'],

    ['s2 n3 f2','s2 n7 f3','s3 n9 f4'],
    ['s2 n3 f2','s2 n9 f4','s3 n9 f4'],
    ['s2 n7 f3','s2 n9 f4','s3 n9 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s2 n2 f1'],
    ['s3 n2 f2','s3 n9 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s2 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n7 f3','s2 n3 f2'],
    ['s3 n2 f1','s3 n9 f4','s2 n3 f2'],

    ['s3 n4 f3','s3 n7 f3','s2 n3 f2'],
    ['s3 n4 f3','s3 n9 f4','s2 n3 f2'],
    ['s3 n7 f3','s3 n9 f4','s2 n3 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s2 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s2 n7 f3'],

    ['s3 n4 f2','s3 n7 f3','s2 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s2 n7 f3'],
    ['s3 n7 f3','s3 n9 f4','s2 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s2 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s2 n9 f4'],

    ['s3 n4 f2','s3 n7 f3','s2 n9 f4'],
    ['s3 n4 f2','s3 n9 f4','s2 n9 f4'],
    ['s3 n7 f3','s3 n9 f4','s2 n9 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s3 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n7 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s3 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s3 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s3 n7 f3'],

    ['s2 n4 f2','s2 n7 f3','s3 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s3 n7 f3'],
    ['s2 n7 f3','s2 n9 f4','s3 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s3 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s3 n9 f4'],

    ['s2 n4 f2','s2 n7 f3','s3 n9 f4'],
    ['s2 n4 f2','s2 n9 f4','s3 n9 f4'],
    ['s2 n7 f3','s2 n9 f4','s3 n9 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s2 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n7 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s2 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s2 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s2 n7 f3'],

    ['s3 n4 f2','s3 n7 f3','s2 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s2 n7 f3'],
    ['s3 n7 f3','s3 n9 f4','s2 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s2 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s2 n9 f4'],

    ['s3 n4 f2','s3 n7 f3','s2 n9 f4'],
    ['s3 n4 f2','s3 n9 f4','s2 n9 f4'],
    ['s3 n7 f3','s3 n9 f4','s2 n9 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s3 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n7 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s3 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n7 f3'],
    ['s2 n2 f1','s2 n7 f2','s3 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s3 n7 f3'],

    ['s2 n4 f2','s2 n7 f2','s3 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s3 n7 f3'],
    ['s2 n7 f2','s2 n9 f4','s3 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s3 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s3 n9 f4'],

    ['s2 n4 f2','s2 n7 f3','s3 n9 f4'],
    ['s2 n4 f2','s2 n9 f4','s3 n9 f4'],
    ['s2 n7 f3','s2 n9 f4','s3 n9 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s2 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n7 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s2 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n7 f4','s2 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s2 n7 f3'],

    ['s3 n4 f2','s3 n7 f4','s2 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s2 n7 f3'],
    ['s3 n7 f4','s3 n9 f4','s2 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f4'],
    ['s3 n2 f1','s3 n7 f3','s2 n7 f4'],
    ['s3 n2 f1','s3 n9 f4','s2 n7 f4'],

    ['s3 n4 f2','s3 n7 f3','s2 n7 f4'],
    ['s3 n4 f2','s3 n9 f4','s2 n7 f4'],
    ['s3 n7 f3','s3 n9 f4','s2 n7 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s3 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n7 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s3 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s3 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s3 n7 f3'],

    ['s2 n4 f2','s2 n7 f3','s3 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s3 n7 f3'],
    ['s2 n7 f3','s2 n9 f4','s3 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s3 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s3 n9 f4'],

    ['s2 n4 f2','s2 n7 f3','s3 n9 f4'],
    ['s2 n4 f2','s2 n9 f4','s3 n9 f4'],
    ['s2 n7 f3','s2 n9 f4','s3 n9 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n7 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n7 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s2 n2 f1'],
    ['s3 n7 f3','s3 n9 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n7 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n7 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s2 n4 f2'],
    ['s3 n7 f3','s3 n9 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n7 f3','s2 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s2 n7 f3'],

    ['s3 n4 f2','s3 n7 f3','s2 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s2 n7 f3'],
    ['s3 n7 f3','s3 n9 f4','s2 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n9 f4'],
    ['s3 n2 f1','s3 n7 f3','s2 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s2 n9 f4'],

    ['s3 n4 f2','s3 n7 f3','s2 n9 f4'],
    ['s3 n4 f2','s3 n9 f4','s2 n9 f4'],
    ['s3 n7 f3','s3 n9 f4','s2 n9 f4'],
  ],
  [
    ['s2 n2 f1','s2 n4 f2','s3 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s3 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s3 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s3 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s3 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s3 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s3 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s3 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s3 n4 f2'],

    ['s2 n4 f2','s2 n7 f3','s3 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s3 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s3 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s3 n8 f3'],
    ['s2 n2 f1','s2 n9 f4','s3 n8 f3'],

    ['s2 n7 f2','s2 n9 f4','s3 n8 f3'],

    ['s2 n2 f1','s2 n4 f2','s3 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s3 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s3 n9 f4'],

    ['s2 n4 f2','s2 n7 f3','s3 n9 f4'],
    ['s2 n4 f2','s2 n9 f3','s3 n9 f4'],
    ['s2 n7 f3','s2 n9 f3','s3 n9 f4'],



    ['s3 n2 f1','s3 n4 f2','s2 n2 f1'],
    ['s3 n2 f1','s3 n8 f3','s2 n2 f1'],
    ['s3 n2 f1','s3 n9 f4','s2 n2 f1'],

    ['s3 n4 f2','s3 n8 f3','s2 n2 f1'],
    ['s3 n4 f2','s3 n9 f4','s2 n2 f1'],
    ['s3 n8 f3','s3 n9 f4','s2 n2 f1'],

    ['s3 n2 f1','s3 n4 f2','s2 n4 f2'],
    ['s3 n2 f1','s3 n8 f3','s2 n4 f2'],
    ['s3 n2 f1','s3 n9 f4','s2 n4 f2'],

    ['s3 n4 f2','s3 n8 f3','s2 n4 f2'],
    ['s3 n4 f2','s3 n9 f4','s2 n4 f2'],
    ['s3 n8 f3','s3 n9 f4','s2 n4 f2'],

    ['s3 n2 f1','s3 n4 f2','s2 n7 f3'],
    ['s3 n2 f1','s3 n8 f4','s2 n7 f3'],
    ['s3 n2 f1','s3 n9 f4','s2 n7 f3'],

    ['s3 n4 f2','s3 n8 f4','s2 n7 f3'],
    ['s3 n4 f2','s3 n9 f4','s2 n7 f3'],
    ['s3 n8 f4','s3 n9 f4','s2 n7 f3'],

    ['s3 n2 f1','s3 n4 f2','s2 n9 f4'],
    ['s3 n2 f1','s3 n8 f3','s2 n9 f4'],
    ['s3 n2 f1','s3 n9 f4','s2 n9 f4'],

    ['s3 n4 f2','s3 n8 f3','s2 n9 f4'],
    ['s3 n4 f2','s3 n9 f4','s2 n9 f4'],
    ['s3 n8 f3','s3 n9 f4','s2 n9 f4'],
  ]

],
eAE:[
  [

    ['s1 n3 f2','s1 n7 f3','s2 n2 f1'],
    ['s1 n3 f2','s1 n8 f4','s2 n2 f1'],
    ['s1 n7 f3','s1 n8 f4','s2 n2 f1'],

    ['s1 n1 f1','s1 n3 f2','s2 n3 f2'],
    ['s1 n1 f1','s1 n7 f3','s2 n3 f2'],
    ['s1 n1 f1','s1 n8 f4','s2 n3 f2'],

    ['s1 n3 f2','s1 n7 f3','s2 n3 f2'],
    ['s1 n3 f2','s1 n8 f4','s2 n3 f2'],
    ['s1 n7 f3','s1 n8 f4','s2 n3 f2'],

    ['s1 n1 f1','s1 n3 f2','s2 n7 f3'],
    ['s1 n1 f1','s1 n7 f3','s2 n7 f3'],
    ['s1 n1 f1','s1 n8 f4','s2 n7 f3'],

    ['s1 n3 f2','s1 n7 f3','s2 n7 f3'],
    ['s1 n3 f2','s1 n8 f4','s2 n7 f3'],
    ['s1 n7 f3','s1 n8 f4','s2 n7 f3'],

    ['s1 n1 f1','s1 n3 f2','s2 n8 f4'],
    ['s1 n1 f1','s1 n7 f3','s2 n8 f4'],
    ['s1 n1 f1','s1 n8 f4','s2 n8 f4'],

    ['s1 n3 f2','s1 n7 f3','s2 n8 f4'],
    ['s1 n3 f2','s1 n8 f4','s2 n8 f4'],
    ['s1 n7 f3','s1 n8 f4','s2 n8 f4'],




    ['s2 n2 f1','s2 n3 f2','s1 n3 f2'],
    ['s2 n2 f1','s2 n7 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n8 f4','s1 n3 f2'],

    ['s2 n3 f2','s2 n7 f3','s1 n3 f2'],
    ['s2 n3 f2','s2 n8 f4','s1 n3 f2'],
    ['s2 n7 f3','s2 n8 f4','s1 n3 f2'],

    ['s2 n2 f1','s2 n3 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s1 n7 f3'],
    ['s2 n2 f1','s2 n8 f4','s1 n7 f3'],

    ['s2 n3 f2','s2 n7 f3','s1 n7 f3'],
    ['s2 n3 f2','s2 n8 f4','s1 n7 f3'],
    ['s2 n7 f3','s2 n8 f4','s1 n7 f3'],

    ['s2 n2 f1','s2 n3 f2','s1 n8 f4'],
    ['s2 n2 f1','s2 n7 f3','s1 n8 f4'],
    ['s2 n2 f1','s2 n8 f4','s1 n8 f4'],

    ['s2 n3 f2','s2 n7 f3','s1 n8 f4'],
    ['s2 n3 f2','s2 n8 f4','s1 n8 f4'],
    ['s2 n7 f3','s2 n8 f4','s1 n8 f4'],
  ],
   [
    ['s1 n2 f1','s1 n3 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n8 f4','s2 n2 f1'],

    ['s1 n3 f2','s1 n7 f3','s2 n2 f1'],
    ['s1 n3 f2','s1 n8 f4','s2 n2 f1'],
    ['s1 n7 f3','s1 n8 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n3 f2','s2 n3 f2'],
    ['s1 n2 f1','s1 n7 f3','s2 n3 f2'],
    ['s1 n2 f1','s1 n8 f4','s2 n3 f2'],

    ['s1 n3 f2','s1 n7 f3','s2 n3 f2'],
    ['s1 n3 f2','s1 n8 f4','s2 n3 f2'],
    ['s1 n7 f3','s1 n8 f4','s2 n3 f2'],

    ['s1 n2 f1','s1 n3 f2','s2 n7 f3'],
    ['s1 n2 f1','s1 n7 f3','s2 n7 f3'],
    ['s1 n2 f1','s1 n8 f4','s2 n7 f3'],

    ['s1 n3 f2','s1 n7 f3','s2 n7 f3'],
    ['s1 n3 f2','s1 n8 f4','s2 n7 f3'],
    ['s1 n7 f3','s1 n8 f4','s2 n7 f3'],

    ['s1 n2 f1','s1 n3 f2','s2 n9 f4'],
    ['s1 n2 f1','s1 n7 f3','s2 n9 f4'],

    ['s1 n3 f2','s1 n7 f3','s2 n9 f4'],



    ['s2 n2 f1','s2 n3 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s1 n2 f1'],

    ['s2 n3 f2','s2 n7 f3','s1 n2 f1'],
    ['s2 n3 f2','s2 n9 f4','s1 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n3 f2','s1 n3 f2'],
    ['s2 n2 f1','s2 n7 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n9 f4','s1 n3 f2'],

    ['s2 n3 f2','s2 n7 f3','s1 n3 f2'],
    ['s2 n3 f2','s2 n9 f4','s1 n3 f2'],
    ['s2 n7 f3','s2 n9 f4','s1 n3 f2'],

    ['s2 n2 f1','s2 n3 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s1 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s1 n7 f3'],

    ['s2 n3 f2','s2 n7 f3','s1 n7 f3'],
    ['s2 n3 f2','s2 n9 f4','s1 n7 f3'],
    ['s2 n7 f3','s2 n9 f4','s1 n7 f3'],

    ['s2 n2 f1','s2 n3 f2','s1 n8 f4'],
    ['s2 n2 f1','s2 n7 f3','s1 n8 f4'],

    ['s2 n3 f2','s2 n7 f3','s1 n8 f4'],
  ],
  [
    ['s1 n2 f1','s1 n3 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n9 f4','s2 n2 f1'],

    ['s1 n3 f2','s1 n7 f3','s2 n2 f1'],
    ['s1 n3 f2','s1 n9 f4','s2 n2 f1'],
    ['s1 n7 f3','s1 n9 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n3 f1','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n9 f4','s2 n4 f2'],

    ['s1 n3 f1','s1 n7 f3','s2 n4 f2'],
    ['s1 n3 f1','s1 n9 f4','s2 n4 f2'],
    ['s1 n7 f3','s1 n9 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n3 f2','s2 n7 f3'],
    ['s1 n2 f1','s1 n7 f3','s2 n7 f3'],
    ['s1 n2 f1','s1 n9 f4','s2 n7 f3'],

    ['s1 n3 f2','s1 n7 f3','s2 n7 f3'],
    ['s1 n3 f2','s1 n9 f4','s2 n7 f3'],
    ['s1 n7 f3','s1 n9 f4','s2 n7 f3'],

    ['s1 n2 f1','s1 n3 f2','s2 n9 f4'],
    ['s1 n2 f1','s1 n7 f3','s2 n9 f4'],
    ['s1 n2 f1','s1 n9 f4','s2 n9 f4'],

    ['s1 n3 f2','s1 n7 f3','s2 n9 f4'],
    ['s1 n3 f2','s1 n9 f4','s2 n9 f4'],
    ['s1 n7 f3','s1 n9 f4','s2 n9 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s1 n2 f1'],
    ['s2 n2 f2','s2 n9 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s1 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n7 f3','s1 n3 f2'],
    ['s2 n2 f1','s2 n9 f4','s1 n3 f2'],

    ['s2 n4 f3','s2 n7 f3','s1 n3 f2'],
    ['s2 n4 f3','s2 n9 f4','s1 n3 f2'],
    ['s2 n7 f3','s2 n9 f4','s1 n3 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s1 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s1 n7 f3'],

    ['s2 n4 f2','s2 n7 f3','s1 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s1 n7 f3'],
    ['s2 n7 f3','s2 n9 f4','s1 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s1 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s1 n9 f4'],

    ['s2 n4 f2','s2 n7 f3','s1 n9 f4'],
    ['s2 n4 f2','s2 n9 f4','s1 n9 f4'],
    ['s2 n7 f3','s2 n9 f4','s1 n9 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n9 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n7 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n9 f4','s2 n2 f1'],
    ['s1 n7 f3','s1 n9 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n9 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n7 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n9 f4','s2 n4 f2'],
    ['s1 n7 f3','s1 n9 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n7 f3'],
    ['s1 n2 f1','s1 n7 f3','s2 n7 f3'],
    ['s1 n2 f1','s1 n9 f4','s2 n7 f3'],

    ['s1 n4 f2','s1 n7 f3','s2 n7 f3'],
    ['s1 n4 f2','s1 n9 f4','s2 n7 f3'],
    ['s1 n7 f3','s1 n9 f4','s2 n7 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n9 f4'],
    ['s1 n2 f1','s1 n7 f3','s2 n9 f4'],
    ['s1 n2 f1','s1 n9 f4','s2 n9 f4'],

    ['s1 n4 f2','s1 n7 f3','s2 n9 f4'],
    ['s1 n4 f2','s1 n9 f4','s2 n9 f4'],
    ['s1 n7 f3','s1 n9 f4','s2 n9 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s1 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n7 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s1 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s1 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s1 n7 f3'],

    ['s2 n4 f2','s2 n7 f3','s1 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s1 n7 f3'],
    ['s2 n7 f3','s2 n9 f4','s1 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s1 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s1 n9 f4'],

    ['s2 n4 f2','s2 n7 f3','s1 n9 f4'],
    ['s2 n4 f2','s2 n9 f4','s1 n9 f4'],
    ['s2 n7 f3','s2 n9 f4','s1 n9 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n9 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n7 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n9 f4','s2 n2 f1'],
    ['s1 n7 f3','s1 n9 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n9 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n7 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n9 f4','s2 n4 f2'],
    ['s1 n7 f3','s1 n9 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n7 f3'],
    ['s1 n2 f1','s1 n7 f2','s2 n7 f3'],
    ['s1 n2 f1','s1 n9 f4','s2 n7 f3'],

    ['s1 n4 f2','s1 n7 f2','s2 n7 f3'],
    ['s1 n4 f2','s1 n9 f4','s2 n7 f3'],
    ['s1 n7 f2','s1 n9 f4','s2 n7 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n9 f4'],
    ['s1 n2 f1','s1 n7 f3','s2 n9 f4'],
    ['s1 n2 f1','s1 n9 f4','s2 n9 f4'],

    ['s1 n4 f2','s1 n7 f3','s2 n9 f4'],
    ['s1 n4 f2','s1 n9 f4','s2 n9 f4'],
    ['s1 n7 f3','s1 n9 f4','s2 n9 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s1 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n7 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s1 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n7 f4','s1 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s1 n7 f3'],

    ['s2 n4 f2','s2 n7 f4','s1 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s1 n7 f3'],
    ['s2 n7 f4','s2 n9 f4','s1 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f4'],
    ['s2 n2 f1','s2 n7 f3','s1 n7 f4'],
    ['s2 n2 f1','s2 n9 f4','s1 n7 f4'],

    ['s2 n4 f2','s2 n7 f3','s1 n7 f4'],
    ['s2 n4 f2','s2 n9 f4','s1 n7 f4'],
    ['s2 n7 f3','s2 n9 f4','s1 n7 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n9 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n7 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n9 f4','s2 n2 f1'],
    ['s1 n7 f3','s1 n9 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n9 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n7 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n9 f4','s2 n4 f2'],
    ['s1 n7 f3','s1 n9 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n7 f3'],
    ['s1 n2 f1','s1 n7 f3','s2 n7 f3'],
    ['s1 n2 f1','s1 n9 f4','s2 n7 f3'],

    ['s1 n4 f2','s1 n7 f3','s2 n7 f3'],
    ['s1 n4 f2','s1 n9 f4','s2 n7 f3'],
    ['s1 n7 f3','s1 n9 f4','s2 n7 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n9 f4'],
    ['s1 n2 f1','s1 n7 f3','s2 n9 f4'],
    ['s1 n2 f1','s1 n9 f4','s2 n9 f4'],

    ['s1 n4 f2','s1 n7 f3','s2 n9 f4'],
    ['s1 n4 f2','s1 n9 f4','s2 n9 f4'],
    ['s1 n7 f3','s1 n9 f4','s2 n9 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n7 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n7 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s1 n2 f1'],
    ['s2 n7 f3','s2 n9 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n7 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n7 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s1 n4 f2'],
    ['s2 n7 f3','s2 n9 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n7 f3','s1 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s1 n7 f3'],

    ['s2 n4 f2','s2 n7 f3','s1 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s1 n7 f3'],
    ['s2 n7 f3','s2 n9 f4','s1 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n9 f4'],
    ['s2 n2 f1','s2 n7 f3','s1 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s1 n9 f4'],

    ['s2 n4 f2','s2 n7 f3','s1 n9 f4'],
    ['s2 n4 f2','s2 n9 f4','s1 n9 f4'],
    ['s2 n7 f3','s2 n9 f4','s1 n9 f4'],
  ],
  [
    ['s1 n2 f1','s1 n4 f2','s2 n2 f1'],
    ['s1 n2 f1','s1 n7 f3','s2 n2 f1'],
    ['s1 n2 f1','s1 n9 f4','s2 n2 f1'],

    ['s1 n4 f2','s1 n7 f3','s2 n2 f1'],
    ['s1 n4 f2','s1 n9 f4','s2 n2 f1'],
    ['s1 n7 f3','s1 n9 f4','s2 n2 f1'],

    ['s1 n2 f1','s1 n4 f2','s2 n4 f2'],
    ['s1 n2 f1','s1 n7 f3','s2 n4 f2'],
    ['s1 n2 f1','s1 n9 f4','s2 n4 f2'],

    ['s1 n4 f2','s1 n7 f3','s2 n4 f2'],
    ['s1 n4 f2','s1 n9 f4','s2 n4 f2'],
    ['s1 n7 f3','s1 n9 f4','s2 n4 f2'],

    ['s1 n2 f1','s1 n4 f2','s2 n8 f3'],
    ['s1 n2 f1','s1 n9 f4','s2 n8 f3'],

    ['s1 n7 f2','s1 n9 f4','s2 n8 f3'],

    ['s1 n2 f1','s1 n4 f2','s2 n9 f4'],
    ['s1 n2 f1','s1 n7 f3','s2 n9 f4'],
    ['s1 n2 f1','s1 n9 f4','s2 n9 f4'],

    ['s1 n4 f2','s1 n7 f3','s2 n9 f4'],
    ['s1 n4 f2','s1 n9 f3','s2 n9 f4'],
    ['s1 n7 f3','s1 n9 f3','s2 n9 f4'],



    ['s2 n2 f1','s2 n4 f2','s1 n2 f1'],
    ['s2 n2 f1','s2 n8 f3','s1 n2 f1'],
    ['s2 n2 f1','s2 n9 f4','s1 n2 f1'],

    ['s2 n4 f2','s2 n8 f3','s1 n2 f1'],
    ['s2 n4 f2','s2 n9 f4','s1 n2 f1'],
    ['s2 n8 f3','s2 n9 f4','s1 n2 f1'],

    ['s2 n2 f1','s2 n4 f2','s1 n4 f2'],
    ['s2 n2 f1','s2 n8 f3','s1 n4 f2'],
    ['s2 n2 f1','s2 n9 f4','s1 n4 f2'],

    ['s2 n4 f2','s2 n8 f3','s1 n4 f2'],
    ['s2 n4 f2','s2 n9 f4','s1 n4 f2'],
    ['s2 n8 f3','s2 n9 f4','s1 n4 f2'],

    ['s2 n2 f1','s2 n4 f2','s1 n7 f3'],
    ['s2 n2 f1','s2 n8 f4','s1 n7 f3'],
    ['s2 n2 f1','s2 n9 f4','s1 n7 f3'],

    ['s2 n4 f2','s2 n8 f4','s1 n7 f3'],
    ['s2 n4 f2','s2 n9 f4','s1 n7 f3'],
    ['s2 n8 f4','s2 n9 f4','s1 n7 f3'],

    ['s2 n2 f1','s2 n4 f2','s1 n9 f4'],
    ['s2 n2 f1','s2 n8 f3','s1 n9 f4'],
    ['s2 n2 f1','s2 n9 f4','s1 n9 f4'],

    ['s2 n4 f2','s2 n8 f3','s1 n9 f4'],
    ['s2 n4 f2','s2 n9 f4','s1 n9 f4'],
    ['s2 n8 f3','s2 n9 f4','s1 n9 f4'],
  ]

],
}
export {tonalitiesCorrespondances,notesCorrespondances,patternsCorrespondances,patternsList};